import html2pdf from "html2pdf.js";
import {
  openingHtmlString,
  closingHtmlString,
  statsTable
} from "./htmlHelpers";

export default {
  showSpinner: false,
  zoomQty: 5,
  zoom: {
    1: 10,
    2: 25,
    3: 50,
    4: 75,
    5: 100,
    6: 125,
    7: 150,
    8: 200
  },
  statsModal: false,
  debug: true,
  listedTeams: [],
  sizeOfBrackets: 4,
  teams: [],
  groups: [],
  single: [],
  ladder: [],
  wildcard: [],
  playoffs: [],
  selectedMatchArr: [],
  circuitMatches: [],
  modal: false,
  disabled: false,
  groupStageFinished: false,
  selectedMatch: null,
  circuitModal: false,
  standings: [],
  matchesByGroups: [],
  showFinalStandings: false,
  isCurrentStage: false,
  loading: false,
  innerLoading: false,
  type: null,
  spec: null,
  qty: 2,
  countBy: "points",
  dragTur: [],
  dragRetur: [],
  competition: null,
  matches: [],
  isVisible: true,
  isDraggable: true,
  isDragging: false,
  rounds: [],
  category: "",
  competitionIsOngoing: true,
  renderComponent: true,
  nextStageIsAvailable: false,
  spanCount: "6",
  canSave: false,
  brackets: [],
  currentStageIndex: 0,
  canFinishCompetition: false,
  partAccess: false,
  teamsTotallySortedArray: [],
  visibilityBetweenStages: false,

  //Schema Select

  updateMatches(newMatches) {
    this.matches = JSON.parse(JSON.stringify(newMatches));
  },
  getTeamNumber(team) {
    return this.teamsTotallySortedArray.findIndex(t => t._id === team._id) + 1;
  },
  async checkFormatIntegrity(comp) {
    try {
      if (
        comp.stages.length > comp.formats.filter(format => format.stage).length
      ) {
        const res = await this.$http.post("/competition/formats/complete", {
          _id: comp._id
        });
        if (res.status === 200) {
          this.getCurrentCompetition(true);
          return;
        }
      } else {
        console.log("Formats are complete");
      }
    } catch (err) {
      console.log(err);
    }
  },
  async updateFormat() {
    try {
      const res = await this.$http.post("/competition/format", {
        _id: this.$route.params.id,
        category: this.$route.params.cat,
        stage: this.competition.stages.find(
          stage => stage.isCurrent && stage.category === this.$route.params.cat
        )._id,
        format_type: this.type,
        count: this.type === "circuit" ? this.countBy : null,
        group_qty: this.type === "group" ? this.qty : null,
        spec: this.type === "circuit" ? this.spec : null,
        sizeOfBrackets: this.type === "group" ? this.sizeOfBrackets : null
      });
      if (res.status === 200) {
        this.getCurrentCompetition(true);
        this.forceRerender();
        this.visibilityBetweenStages = false;
      }
    } catch (err) {
      console.log(err);
    }
  },
  async getCurrentCompetition(src) {
    try {
      const res = await this.$http.post("/competition/find", {
        _id: this.$route.params.id
      });
      this.competition = res.data;
      await this.checkStageCategories();
      await this.checkFormatIntegrity(this.competition);
      if (
        !this.competition.stages.some(
          stage =>
            stage._id.toString() === localStorage.getItem("chosenStage") &&
            stage.category === this.$route.params.cat
        ) ||
        !this.competition.stages.filter(
          stage => stage.isCurrent && stage.category === this.$route.params.cat
        ).length
      ) {
        await this.forceAddCurrentStage();
      }
      this.competition.stages.forEach(stage => {
        stage.isChosen = localStorage.getItem("chosenStage") === stage._id;
      });
      if (src) {
        let cond = this.competition.formats.find(
          ({ category, stage }) =>
            category._id === this.$route.params.cat &&
            stage === localStorage.getItem("chosenStage")
        );
        if (cond) {
          this.type = cond.format_type;
          this.qty = cond.group_qty;
          this.spec = cond.spec;
          this.sizeOfBrackets = cond.sizeOfBrackets;
          this.countBy = cond.count;
        }
        console.log(
          "PARAMS",
          this.type,
          this.qty,
          this.spec,
          this.sizeOfBrackets
        );
        if (this.type === "group" && this.sizeOfBrackets && this.qty)
          this.isVisible = false;
        else if (this.type === "circuit" && this.spec && this.countBy)
          this.isVisible = false;
        else {
          this.visibilityBetweenStages = true;
          this.isVisible = false;
        }
        this.matches = [];
      }
    } catch (error) {
      console.log(error);
    }
  },
  forceRerender() {
    this.renderComponent = false;

    this.$nextTick(() => {
      this.renderComponent = true;
    });
  },
  getCategory() {
    return this.competition.formats.find(
      cat => cat.category._id === this.$route.params.cat
    ).category;
  },
  async addMoreMatches() {
    this.loading = true;
    if (this.type === "group") {
      const updatedDate = new Date(this.competition.date[1]);
      updatedDate.setDate(updatedDate.getDate() - 7);
      await this.$http.post("/competition/rounds", {
        stageId: this.competition.stages.find(
          stage => stage.isCurrent && stage.category === this.$route.params.cat
        )._id,
        rounds: [
          {
            name: "Playoff",
            date_start: updatedDate,
            isPlayoff: true,
            category: this.$route.params.cat
          }
        ]
      });
    }
    let DBMatches = this.matches.filter(
      match => !match.isFinished && !match._id
    );
    if (this.type === "circuit" && this.spec === "twoway") {
      DBMatches = this.dragTur.concat(this.dragRetur);
    } else if (this.type === "group") {
      DBMatches = this.matchesByGroups.flat();
    }
    await this.$http.post("/match/addMany", DBMatches);
    this.loading = false;
    await this.getCurrentCompetition(false);
  },
  async deleteMatches() {
    this.loading = true;
    await this.$http.post("/match/deleteOrder", {
      stage: this.competition.stages.find(
        stage =>
          stage.category === this.$route.params.cat &&
          stage.isChosen &&
          stage.isCurrent
      )
    });
    this.loading = false;
    await this.getCurrentCompetition(false);
  },
  async saveRounds(roundsToPush) {
    this.rounds = JSON.parse(JSON.stringify(roundsToPush));
  },
  checkModal(match) {
    if (!this.isVisible) {
      if ((this.partAccess && match.isFinished) || !this.partAccess) {
        this.openModal(match);
      }
    } else {
      console.log("checkModal");
    }
  },
  getSlot(type, match) {
    let className = "";
    if (type === "top") {
      className =
        this.getPoints(match.home_players, match, match.home_team) >
        this.getPoints(match.away_players, match, match.away_team)
          ? "slot-winner"
          : "";
    } else if (type === "bottom") {
      className =
        this.getPoints(match.away_players, match, match.away_team) >
        this.getPoints(match.home_players, match, match.home_team)
          ? "slot-winner"
          : "";
    }
    return className;
  },
  async savePlayerRegistrationStatus() {
    try {
      const res = await this.$http.post("/team/players/status", this.teams);
      console.log(res);
    } catch (error) {
      console.log(error);
    }
  },
  async save() {
    console.log({ SIZEOFBRACKETS: this.sizeOfBrackets });
    try {
      await this.$http.post("/competition/format", {
        _id: this.$route.params.id,
        category: this.$route.params.cat,
        stage: this.competition.stages.find(
          stage => stage.isCurrent && stage.category === this.$route.params.cat
        )._id,
        format_type: this.type,
        group_qty: this.type === "group" ? this.qty : null,
        spec: this.type === "circuit" ? this.spec : null,
        count: this.type === "circuit" ? this.countBy : null,
        sizeOfBrackets: this.type === "group" ? this.sizeOfBrackets : null
      });
      if (this.type === "group") {
        const updatedDate = new Date(this.competition.date[1]);
        updatedDate.setDate(updatedDate.getDate() - 7);
        await this.$http.post("/competition/rounds", {
          stageId: this.competition.stages.find(
            stage =>
              stage.isCurrent && stage.category === this.$route.params.cat
          )._id,
          rounds: [
            {
              name: "Playoff",
              date_start: updatedDate,
              isPlayoff: true,
              category: this.$route.params.cat
            }
          ]
        });
      }
      await this.savePlayerRegistrationStatus();
      let DBMatches = this.matches;
      if (this.type === "circuit" && this.spec === "twoway") {
        DBMatches = this.dragTur.concat(this.dragRetur);
      } else if (this.type === "group") {
        DBMatches = this.matchesByGroups.flat();
      }
      await this.$http.post("/match/addMany", DBMatches);
      await this.getCurrentCompetition(true);
      this.forceRerender();
    } catch (error) {
      console.log("error :>> ", error);
    }
  },
  async close(src) {
    this.circuitModal = false;
    if (src) {
      this.forceRerender();
      await this.getCurrentTeams();
      this.listedTeams = this.sortByStageStats(
        JSON.parse(JSON.stringify([...this.teams])),
        true
      );
      this.checkFinishCompetition();
    }
  },
  async getDisqualified(match) {
    try {
      const res = await this.$http.post("/team/disqualified", {
        teamId: match.home_team._id,
        matchId: match._id
      });
    } catch (error) {
      console.log("home", error);
    }
    try {
      const res = await this.$http.post("/team/disqualified", {
        teamId: match.away_team._id,
        matchId: match._id
      });
    } catch (error) {
      console.log("away", error);
    }
  },
  getMatcheStadium(item) {
    let ifStadium = item.stadium ? item.stadium : item.stage.stadium;
    return ifStadium;
  },
  async getUpdatedCompetition() {
    try {
      const res = await this.$http.post("/competition/find", {
        _id: this.$route.params.id
      });
      this.competition = res.data;
      this.competition.stages.forEach(stage => {
        stage.isChosen = localStorage.getItem("chosenStage") === stage._id;
      });
    } catch (e) {
      console.log(e);
    }
  },
  async setCurrentStage(_id, isCurrent) {
    try {
      const res = await this.$http.post("/competition/editStage", {
        _id,
        isCurrent
      });
    } catch (e) {
      console.log(e);
    }
  },
  async detectCurrentStage() {
    for (
      let i = this.competition.stages
        .filter(stage => stage.category === this.$route.params.cat)
        .findIndex(stage => stage.isCurrent);
      i <
      this.competition.stages.filter(
        stage => stage.category === this.$route.params.cat
      ).length;
      i++
    ) {
      const stage = this.competition.stages.filter(
        stage => stage.category === this.$route.params.cat
      )[i];
      const res = await this.$http.post("/match/list", { stage: stage._id });
      if (
        res.data.length &&
        res.data.every(match => match.isFinished) &&
        (this.type === "group"
          ? this.playoffs.every(match => match.isFinished)
          : true)
      ) {
        await this.setCurrentStage(stage._id, false);
        if (
          i ===
          this.competition.stages.filter(
            stage => stage.category === this.$route.params.cat
          ).length -
            1
        ) {
          this.competitionIsOngoing = false;
          await this.getCurrentCompetition(true);
          this.forceRerender();
          break;
        }
      } else {
        if (!(stage.isCurrent && stage.category === this.$route.params.cat)) {
          await this.setCurrentStage(stage._id, true);
          await this.setStage(stage._id);
          await this.getUpdatedCompetition();
          this.saveRounds(
            this.competition.stages.find(
              stage =>
                stage.isCurrent && stage.category === this.$route.params.cat
            ).rounds
          );
          this.updateMatches([]);
          if (this.type === "circuit") await this.getUpdatedCompetition();
          await this.getExtendedCurrentTeams();
          // if (this.type === "circuit") await this.addMoreMatches();
          if (this.type === "group") {
            await this.getExtendedCurrentTeams();
            if (this.type === "group") {
              this.groupStageFinished = false;
              this.showFinalStandings = false;
              this.playoffs = [];
              this.brackets = [];
            }
          }
          this.forceRerender();
          break;
        }
      }
    }
  },
  async updateMatchTeamPlayers(team_id, players, team, stage) {
    let form = {
      team_id,
      newPlayers: players,
      team,
      stage
    };
    try {
      let res = await this.$http.post("/match/addPlayersToTeam", form);
      console.log(res);
    } catch (error) {
      console.log(error);
    }
  },
  async checkStageCategories() {
    if (this.competition && this.competition.formats.length > 0) {
      try {
        const res = await this.$http.post("/competition/updateStages", {
          compId: this.competition._id
        });
        if (res.status === 201) {
          await this.getCurrentCompetition(true);
        }
        console.log(res);
      } catch (error) {
        console.log(error);
      }
    }
  },
  async checkTeamIntegrity() {
    console.log(this.teams, this.matches);
    let checked = false;
    let alreadyHomeChecked = [];
    let alreadyAwayChecked = [];

    for (const match of this.matches) {
      const awayTeam = this.teams.find(
        team => team._id === match.away_team._id
      );
      const homeTeam = this.teams.find(
        team => team._id === match.home_team._id
      );

      if (!awayTeam || !homeTeam) {
        continue;
      }

      const awayPlayersDiscrepancy =
        awayTeam.players.length > match.away_players.length;
      const homePlayersDiscrepancy =
        homeTeam.players.length > match.home_players.length;

      if (
        awayPlayersDiscrepancy &&
        !alreadyAwayChecked.includes(match.away_team._id)
      ) {
        const missingPlayers = awayTeam.players.filter(
          ({ player }) =>
            !match.away_players.some(
              athlete => athlete.player._id === player._id
            )
        );
        await this.updateMatchTeamPlayers(
          match.away_team._id,
          missingPlayers,
          "away",
          this.competition.stages.find(
            stage =>
              stage.isCurrent && stage.category === this.$route.params.cat
          )._id
        );
        alreadyAwayChecked.push(match.away_team._id);
        checked = true;
      } else if (
        homePlayersDiscrepancy &&
        !alreadyHomeChecked.includes(match.home_team._id)
      ) {
        const missingPlayers = homeTeam.players.filter(
          ({ player }) =>
            !match.home_players.some(
              athlete => athlete.player._id === player._id
            )
        );
        await this.updateMatchTeamPlayers(
          match.home_team._id,
          missingPlayers,
          "home",
          this.competition.stages.find(
            stage =>
              stage.isCurrent && stage.category === this.$route.params.cat
          )._id
        );
        alreadyHomeChecked.push(match.home_team._id);
        checked = true;
      }
    }

    if (checked) {
      await this.getAllMatches(
        !this.competition.stages.filter(
          stage => stage.isChosen && stage.category === this.$route.params.cat
        ).length
          ? [
              this.competition.stages.find(
                stage =>
                  stage.isCurrent && stage.category === this.$route.params.cat
              )
            ]
          : [
              this.competition.stages.find(
                stage =>
                  stage.isChosen && stage.category === this.$route.params.cat
              )
            ]
      );
    }
  },
  async setStage(_id) {
    const stageToChange = this.competition.stages.find(
      stage => stage._id === _id
    )._id;
    localStorage.setItem("chosenStage", stageToChange);

    await this.getCurrentCompetition(true);
    await this.getExtendedCurrentTeams();
    this.currentStageIndex = this.competition.stages.findIndex(
      stage =>
        (stage.isChosen ? stage.isChosen : stage.isCurrent) &&
        stage.category === this.$route.params.cat
    );
    this.listedTeams = this.sortByStageStats(
      JSON.parse(JSON.stringify([...this.teams])),
      true
    );
    if (this.type === "circuit") {
      this.checkFinishCompetition();
      this.forceRerender();
    } else if (this.type === "group") {
      this.brackets = [];
      this.groupStageFinished = false;
      if (
        this.competition.stages[
          this.competition.stages.findIndex(
            stage => stage.isChosen && stage.category === this.$route.params.cat
          ) + 1
        ]
      )
        await this.checkStageAvailability([
          this.competition.stages[
            this.competition.stages.findIndex(
              stage =>
                stage.isChosen && stage.category === this.$route.params.cat
            ) + 1
          ]
        ]);
      this.checkFinishCompetition();
      this.forceRerender();
    }
  },
  getSEMatchQty(n) {
    if (n > 1) {
      return n + 2 * this.getSEMatchQty(n / 2);
    }
    return n;
  },
  getWCMatchQty(n) {
    if (n <= 2) {
      if (n > 1) {
        return 3 * n + 1;
      } else return n;
    } else return 2 * this.getWCMatchQty(n / 2) + n * 1.5;
  },
  async generateMatchesPDF() {
    this.loading = true;
    let quantity = this.matches.filter(
      match =>
        match.stage._id.toString() ===
        localStorage.getItem("chosenStage").toString()
    ).length;
    let countPlayoffMathces = Math.floor(
      this.teams.length / this.sizeOfBrackets
    );
    let remainderTeams = this.teams.length % this.sizeOfBrackets;
    if (this.type === "group" && this.sizeOfBrackets === 6) {
      quantity += this.getWCMatchQty(2) * countPlayoffMathces;
      if (remainderTeams > 0) {
        quantity += this.getSEMatchQty(Math.floor(remainderTeams / 2));
      }
    } else if (this.type === "group" && this.sizeOfBrackets !== 6) {
      quantity +=
        this.getSEMatchQty(this.sizeOfBrackets / 2) * countPlayoffMathces;
      if (remainderTeams > 0) {
        quantity += this.getSEMatchQty(Math.floor(remainderTeams / 2));
      }
    }
    console.log(this.matches.length);
    try {
      let response = await this.$http.post("/match/pdf", {
        qty: quantity,
        stage: this.competition.stages.find(stage => stage.isChosen),
        competition: this.competition
      });
      let html = response.data.renderedMatches;
      let tableResponse = await this.$http.post("/match/table/pdf", {
        teams: this.teamsTotallySortedArray,
        competition: this.competition,
        category: this.$route.params.cat,
        stage: this.competition.stages.find(stage => stage.isChosen)
      });
      let contentTable = tableResponse.data;
      // var blob = new Blob([html], { type: "text/html" });

      // var url = URL.createObjectURL(blob);

      // window.open(url, "_blank");

      // URL.revokeObjectURL(url);
      let upperHTML;
      let temp = document.createElement("div");
      temp.innerHTML = html;
      let parser = new DOMParser();
      const htmlDoc = parser.parseFromString(html, "text/html");
      const opt = {
        margin: 3,
        filename: "matches.pdf"
      };
      const pages = Array.from(
        htmlDoc.querySelectorAll('div[aria-label^="pdf-page-"]')
      );

      let content = pages.map(page => {
        return openingHtmlString + page.innerHTML + closingHtmlString;
      });
      content.unshift(response.data.schedule);
      content.unshift(contentTable);
      console.log(content);
      let worker = html2pdf()
        .set(opt)
        .from(content[0]);

      worker = worker.toPdf(); // worker is now a jsPDF instance

      if (content.length > 1) {
        // add each element/page individually to the PDF render process
        content.slice(1).forEach((page, index) => {
          worker = worker
            //worker = worker.toPdf() // worker is now a jsPDF instance
            .get("pdf")
            .then(pdf => {
              pdf.addPage();
            })
            .from(page)
            .toContainer()
            .toCanvas()
            .toPdf();
        });
      }
      await worker.toPdf().save();

      this.loading = false;
    } catch (error) {
      console.log(error);
    }
  },
  async forceAddCurrentStage() {
    let neededStages = this.competition.stages.filter(
      stage => stage.isCurrent && stage.category === this.$route.params.cat
    );
    let extraStages = this.competition.stages.filter(
      stage => stage.category === this.$route.params.cat
    );
    if (neededStages.length === 0 && this.competition.formats.length > 0) {
      try {
        let res = await this.$http.post("/competition/editStage", {
          _id: extraStages[0]._id,
          isCurrent: true
        });
        localStorage.setItem("chosenStage", res.data._id);
        await this.getCurrentCompetition(true);
      } catch (error) {
        console.log(error);
      }
    } else {
      localStorage.setItem(
        "chosenStage",
        this.competition.stages.find(
          stage => stage.isCurrent && stage.category === this.$route.params.cat
        )._id
      );
    }
  },
  checkFinishCompetition() {
    if (this.competition) {
      let a =
        this.competition.stages.findIndex(
          stage =>
            stage.isChosen &&
            stage.isCurrent &&
            stage.category === this.$route.params.cat
        ) ===
        this.competition.stages.length - 1;
      let b;
      if (this.type === "group") {
        b =
          this.matches.every(match => match.isFinished) &&
          this.playoffs.every(match => match.isFinished);
      } else {
        b = this.matches.every(match => match.isFinished);
      }
      let c = !this.competition.isCompleted;
      let d = !this.partAccess;
      this.canFinishCompetition = Boolean(a && b && c && d);
    }
  },
  async checkStageAvailability(stages) {
    try {
      const res = await this.$http.post("/match/getMany", {
        stages: stages,
        category: this.$route.params.cat
      });
      if (res.data.length) {
        this.nextStageIsAvailable = false;
      } else {
        this.nextStageIsAvailable = true;
      }
    } catch (error) {
      console.log(error);
    }
  },
  async getAllMatches(stages) {
    try {
      let results = [];
      const res = await this.$http.post("/match/getMany", {
        stages: stages,
        category: this.$route.params.cat
      });
      results.push(...res.data);
      this.updateMatches(results);
    } catch (error) {
      console.log(error);
    }
    this.loading = false;
  },
  getDateMatches(date) {
    if (date) {
      let dates = new Date(date).toLocaleDateString();
      let replaceDate = dates.replace(/[/]/g, ":");

      const dateStart = new Date(date);
      let startHours = dateStart.getHours();
      let startMinutes = dateStart.getMinutes();

      if (startHours < 10) {
        startHours = "0" + startHours;
      }

      if (startMinutes < 10) {
        startMinutes = "0" + startMinutes;
      }

      let hours = startHours + ":" + startMinutes;

      return `${replaceDate}; ${hours}`;
    } else {
      return "";
    }
  },
  async generateRounds() {
    const roundsToPush = [];
    let currentAmountOfRounds;
    let currentAmountOfRoundsInGroups =
      Math.ceil(this.teams.length / this.groups.length) % 2 === 0
        ? Math.ceil(this.teams.length / this.groups.length - 1)
        : Math.ceil(this.teams.length / this.groups.length);
    let currentAmountOfRoundsInCircuits =
      this.teams.length % 2 === 0 ? this.teams.length - 1 : this.teams.length;
    if (this.type === "group") {
      currentAmountOfRounds = currentAmountOfRoundsInGroups;
    } else if (this.type === "circuit") {
      currentAmountOfRounds = currentAmountOfRoundsInCircuits;
    }
    let neededStage = this.competition.stages.find(
      stage => stage.isCurrent && stage.category === this.$route.params.cat
    );
    for (let i = 0; i < currentAmountOfRounds; i++) {
      roundsToPush.push({
        name: "Round " + (i + 1),
        date_start: new Date(),
        stage: neededStage._id,
        stadium: neededStage.stadium,
        spends: neededStage.spends,
        category: this.$route.params.cat,
        _id: i
      });
    }
    this.saveRounds(roundsToPush);
  },
  async getMatches() {
    try {
      let result = [];
      for (
        let i = 0;
        i <
        this.rounds.filter(
          round => round.category === this.$route.params.cat && !round.isPlayoff
        ).length;
        i++
      ) {
        const element = this.rounds.filter(
          round => round.category === this.$route.params.cat && !round.isPlayoff
        )[i];
        const res = await this.$http.post("/match/list", {
          round: element._id
        });
        result.push(...res.data);
      }
      if (result.length > 0) {
        this.updateMatches(result);
      }
    } catch (error) {
      console.log(error);
    }
  },
  async CircuitGenerate() {
    if (this.competitionIsOngoing) {
      if (
        !this.rounds.filter(
          round =>
            round.category === this.$route.params.cat &&
            round.stage ===
              this.competition.stages.find(
                stage =>
                  (stage.isChosen ? stage.isChosen : stage.isCurrent) &&
                  stage.category === this.$route.params.cat
              )._id
        ).length
      ) {
        this.generateRounds();
      }
    }
    if (!this.isVisible) {
      !this.competition.stages.filter(
        stage => stage.isChosen && stage.category === this.$route.params.cat
      ).length
        ? await this.getAllMatches([
            this.competition.stages.find(
              stage =>
                stage.isCurrent && stage.category === this.$route.params.cat
            )
          ])
        : await this.getAllMatches([
            this.competition.stages.find(
              stage =>
                stage.isChosen && stage.category === this.$route.params.cat
            )
          ]);
    }
    if (this.type === "circuit") {
      if (this.spec === "oneway") {
        this.checkForMatches();
      } else if (this.spec === "twoway") {
        this.checkForPairMatches();
      }
    }
  },
  turnOnInbetweenStagesVisibility() {
    console.log(
      "TURNINGON",
      this.isDraggable,
      !this.matches.filter(match => match._id).length
    );
    if (this.isDraggable && !this.matches.filter(match => match._id).length) {
      this.visibilityBetweenStages = true;
    } else {
      this.visibilityBetweenStages = false;
    }
  },
  async getCurrentTeams(extra) {
    this.loading = true;
    try {
      const res = await this.$http.post("/team/list", {
        competition_id: this.competition._id,
        category: this.$route.params.cat
        // stageId: this.competition.stages.find((stage) => stage.isChosen && stage.category === this.$route.params.cat)._id
      });
      this.teams = res.data;
      // .filter(
      //   team => team.players.length >= team.ttype.max_count
      // );
      if (this.type === "circuit" && this.teams.length < 2) {
        this.canSave = false;
      } else if (this.type === "group" && this.teams.length < 4) {
        this.canSave = false;
      } else if (
        (this.type === "circuit" && this.teams.length >= 2) ||
        (this.type === "group" && this.teams.length >= 4 && this.sizeOfBrackets)
      ) {
        console.log("here1");
        this.canSave = true;
      }
      console.log(this.canSave);
      let stageCheck = this.competition.stages.find(
        stage => stage.isChosen && stage.category === this.$route.params.cat
      )._id;
      for (let i = 0; i < this.teams.length; i++) {
        const team = this.teams[i];
        let indexArray = team.group.map(item => {
          return { index: item.index, stage: item.stage };
        });
        if (
          team.group.map(item => item.stage).toString() !==
          this.competition.stages
            .filter(stage => stage.category === this.$route.params.cat)
            .map(stage => stage._id)
            .toString()
        ) {
          this.teams[i].group = this.competition.stages
            .filter(stage => stage.category === this.$route.params.cat)
            .map(stage => {
              return { stage: stage._id };
            });
          for (let j = 0; j < indexArray.length; j++) {
            const element = indexArray[j];
            if (
              this.teams[i].group.find(item => item.stage === element.stage)
            ) {
              console.log("DONE");
              this.teams[i].group.find(
                item => item.stage === element.stage
              ).index = element.index;
            }
          }
          await this.updateTeamStages(this.teams[i]);
        }
      }
      if (
        this.teams.some(
          team =>
            team.group.find(({ stage }) => stage === stageCheck) &&
            team.group
              .find(({ stage }) => stage === stageCheck)
              .hasOwnProperty("index")
        )
      ) {
        this.isDraggable = false;
      } else {
        this.isDraggable = true;
      }
      let extraTeams = [...this.teams];
      extraTeams.forEach(t => {
        for (let i = 0; i < t.statistics.stages.length; i++) {
          const stage = t.statistics.stages[i];
          t.statistics.stages[i].pts = stage.points;
        }
      });
      await this.teams.forEach(async team => {
        if (team.statistics) {
          team.statistics.stages.sort((a, b) =>
            a.stage.name.slice(-1) < b.stage.name.slice(-1) ? -1 : 1
          );
          let index = 1;
          while (
            team.statistics.stages.length <
            this.competition.stages.filter(
              stage => stage.category === team.category._id
            ).length
          ) {
            if (
              team.statistics.stages.some(
                ({ stage }) => stage.name.slice(-1) === index.toString()
              )
            ) {
              index++;
            } else if (
              team.statistics.stages.some(
                ({ stage }) => stage.name.slice(-1) > index.toString()
              )
            ) {
              team.statistics.stages.unshift({
                stage: { _id: index, name: "Etapa " + index },
                scored: 0,
                conceded: 0,
                points: 0
              });
            } else if (
              team.statistics.stages.some(
                ({ stage }) => stage.name.slice(-1) < index.toString()
              )
            ) {
              team.statistics.stages.push({
                stage: { _id: index, name: "Etapa " + index },
                scored: 0,
                conceded: 0,
                points: 0
              });
            }
          }
          let counter = 0;
          this.loading = true;
          if (extra)
            for (let i = 0; i < team.statistics.stages.length; i++) {
              const stage = team.statistics.stages[i];
              let cond = this.competition.formats.find(
                format =>
                  format.stage === stage.stage._id &&
                  format.category._id === stage.stage.category
              );

              if (cond && cond.format_type === "group") {
                let standings = await this.getStandingsByStage(
                  [
                    this.competition.stages.find(
                      stag => stag._id === stage.stage._id
                    )
                  ],
                  stage.stage.category
                );
                if (standings && standings.length) {
                  standings.push(
                    ...this.teams
                      .filter(
                        team =>
                          standings.length &&
                          team.category._id === standings[0].category
                      )
                      .filter(
                        team =>
                          !standings.some(standing => standing._id === team._id)
                      )
                  );
                  standings.forEach(
                    place =>
                      (place.rating =
                        standings.length - standings.indexOf(place))
                  );
                  let stand = standings.find(
                    standing => standing._id === team._id
                  );
                  if (stand) team.statistics.stages[i].points = stand.rating;
                }
              }

              let arbitraryTeams =
                cond &&
                this.sortByCertainStageStats(
                  extraTeams,
                  cond.stage,
                  cond.category._id
                );
              if (cond && cond.count === "places") {
                team.statistics.stages[i].points =
                  arbitraryTeams.length -
                  arbitraryTeams.findIndex(item => item._id === team._id);
              }
              console.log({
                arbitraryTeamsCounter:
                  cond &&
                  cond.count === "places" &&
                  team.statistics.stages[i].points,
                team: team.name,
                arbitraryTeams:
                  arbitraryTeams && arbitraryTeams.map(te => te.name),
                allTeams: this.teams.map(te => te.name)
              });
              counter += team.statistics.stages[i].points;
            }
          team.statistics.totalScored = team.statistics.stages.reduce(
            (acc, item) => acc + item.scored,
            0
          );
          team.statistics.totalConceded = team.statistics.stages.reduce(
            (acc, item) => acc + item.conceded,
            0
          );
          if (!counter) {
            for (let i = 0; i < team.statistics.stages.length; i++) {
              const element = team.statistics.stages[i];
              let cond = this.competition.formats.find(
                format => format.stage === element.stage._id
              );
              if (cond && cond.format_type === "group") {
                let stand = this.standings.find(
                  standing => standing._id === team._id
                );
                counter += stand && stand.rating;
              } else {
                counter += element.points;
              }
            }
          }
          team.statistics.totalPoints = counter;
          // team.statistics.totalPoints = team.statistics.stages.reduce(
          //   (acc, item) => acc + this.competition.formats.find((format) => format.stage === item._id).format_type === 'group' ? this.standings.find((standing) => standing._id === team._id).rating : item.points,
          //   0
          // );
        }
      });
      this.teamsTotallySortedArray = this.teams.sort(this.sortByTotalStats);
      console.log({ ttsa: this.teamsTotallySortedArray });
      this.listedTeams = this.sortByStageStats(
        JSON.parse(JSON.stringify([...this.teamsTotallySortedArray])),
        true
      );
      setTimeout(() => {
        this.loading = false;
      }, 500);
    } catch (error) {
      console.log("error :>> ", error);
    }

    setTimeout(() => {
      this.loading = false;
    }, 500);
  },
  async getExtendedCurrentTeams() {
    this.loading = true;
    try {
      const res = await this.$http.post("/team/list", {
        competition_id: this.competition._id,
        category: this.$route.params.cat
      });
      this.teams = res.data;
      // .filter(
      //   team => team.players.length >= team.ttype.max_count
      // );
      if (this.type === "circuit" && this.teams.length < 2) {
        this.canSave = false;
      } else if (this.type === "group" && this.teams.length < 4) {
        this.canSave = false;
      } else if (
        (this.type === "circuit" && this.teams.length >= 2) ||
        (this.type === "group" && this.teams.length >= 4 && this.sizeOfBrackets)
      ) {
        console.log("here");
        this.canSave = true;
      }
      console.log(this.canSave);
      if (
        this.teams.some(team =>
          team.group
            .find(({ stage }) => {
              let temp = this.competition.stages.find(
                stage =>
                  stage.isChosen && stage.category === this.$route.params.cat
              );
              if (temp) return stage === temp._id;
            })
            .hasOwnProperty("index")
        )
      ) {
        this.isDraggable = false;
      } else {
        this.isDraggable = true;
      }
      this.teams.forEach(team => {
        if (team.statistics) {
          team.statistics.stages.sort((a, b) =>
            a.stage.name.slice(-1) < b.stage.name.slice(-1) ? -1 : 1
          );
          let index = 1;

          while (
            team.statistics.stages.length <
            this.competition.stages.filter(
              stage => stage.category === team.category._id
            ).length
          ) {
            if (
              team.statistics.stages.some(
                ({ stage }) => stage.name.slice(-1) === index.toString()
              )
            ) {
              index++;
            } else if (
              team.statistics.stages.some(
                ({ stage }) => stage.name.slice(-1) > index.toString()
              )
            ) {
              team.statistics.stages.unshift({
                stage: { _id: index, name: "Etapa " + index },
                scored: 0,
                conceded: 0,
                points: 0
              });
            } else if (
              team.statistics.stages.some(
                ({ stage }) => stage.name.slice(-1) < index.toString()
              )
            ) {
              team.statistics.stages.push({
                stage: { _id: index, name: "Etapa " + index },
                scored: 0,
                conceded: 0,
                points: 0
              });
            }
          }
          team.statistics.totalScored = team.statistics.stages.reduce(
            (acc, item) => acc + item.scored,
            0
          );
          team.statistics.totalConceded = team.statistics.stages.reduce(
            (acc, item) => acc + item.conceded,
            0
          );
          let counter = 0;
          for (let i = 0; i < team.statistics.stages.length; i++) {
            const element = team.statistics.stages[i];
            let cond = this.competition.formats.find(
              format => format.stage === element.stage._id
            );
            if (cond && cond.format_type === "group") {
              let stand = this.standings.find(
                standing => standing._id === team._id
              );
              counter += stand && stand.rating;
            } else {
              counter += element.points;
            }
          }
          team.statistics.totalPoints = counter;
        }
      });
      this.teamsTotallySortedArray = this.teams.sort(this.sortByTotalStats);
      console.log({ ttsa: this.teamsTotallySortedArray });
      this.listedTeams = this.sortByStageStats(
        JSON.parse(JSON.stringify([...this.teamsTotallySortedArray])),
        true
      );
      if (this.type === "group") {
        this.formGroups();
      }
      if (this.competitionIsOngoing) {
        if (
          !this.rounds.filter(
            round =>
              round.category === this.$route.params.cat &&
              round.stage ===
                this.competition.stages.find(
                  stage =>
                    (stage.isChosen ? stage.isChosen : stage.isCurrent) &&
                    stage.category === this.$route.params.cat
                )._id
          ).length
        ) {
          this.generateRounds();
        }
      }
      if (!this.isVisible) {
        !this.competition.stages.filter(
          stage => stage.isChosen && stage.category === this.$route.params.cat
        ).length
          ? await this.getAllMatches([
              this.competition.stages.find(
                stage =>
                  stage.isCurrent && stage.category === this.$route.params.cat
              )
            ])
          : await this.getAllMatches([
              this.competition.stages.find(
                stage =>
                  stage.isChosen && stage.category === this.$route.params.cat
              )
            ]);
      }
      if ((this.sizeOfBrackets & (this.sizeOfBrackets - 1)) === 0) {
        if (
          this.isVisible ||
          !this.matches.filter(
            match =>
              match.stage._id ===
              this.competition.stages.find(
                stage =>
                  (stage.isChosen ? stage.isChosen : stage.isCurrent) &&
                  stage.category === this.$route.params.cat
              )._id
          ).length
        ) {
          this.generateRoundRobinSchedule(true);
        } else {
          await this.goToPlayoffs();
        }
      } else if (this.spec === "stepladder") {
        if (
          this.isVisible ||
          !this.matches.filter(
            match =>
              match.stage._id ===
              this.competition.stages.find(
                stage =>
                  (stage.isChosen ? stage.isChosen : stage.isCurrent) &&
                  stage.category === this.$route.params.cat
              )._id
          ).length
        ) {
          this.generateRoundRobinSchedule(true);
        } else {
          await this.goToPlayoffs();
        }
      } else if ((this.sizeOfBrackets & (this.sizeOfBrackets - 1)) !== 0) {
        if (
          this.isVisible ||
          !this.matches.filter(
            match =>
              match.stage._id ===
              this.competition.stages.find(
                stage =>
                  (stage.isChosen ? stage.isChosen : stage.isCurrent) &&
                  stage.category === this.$route.params.cat
              )._id
          ).length
        ) {
          this.generateRoundRobinSchedule(true);
        } else {
          await this.goToPlayoffs();
        }
      }
      if (this.type === "circuit") {
        if (this.spec === "oneway") {
          this.checkForMatches();
        } else if (this.spec === "twoway") {
          this.checkForPairMatches();
        }
      }
      this.checkFinishCompetition();
      this.loading = false;
    } catch (error) {
      console.log("error :>> ", error);
      this.loading = false;
    }
  },
  getPoints(arr, match, team) {
    if (arr && arr.length && match) {
      if (match.tech_loser) {
        if (match.tech_loser === team._id) return 0;
        else return 28;
      }
      return arr.reduce((acc, item) => acc + item.points, 0);
    }
    return 0;
  },
  checkForMatches() {
    let checker = 0;
    if (this.teams.length % 2 === 0) {
      checker =
        (this.teams.length / 2) *
        this.rounds.filter(round => round.category === this.$route.params.cat)
          .length;
    } else {
      checker =
        Math.floor(this.teams.length / 2) *
        this.rounds.filter(round => round.category === this.$route.params.cat)
          .length;
    }
    const matchesMap = new Map();
    if (this.matches.length)
      for (const existingMatch of this.matches) {
        const matchKey = `${existingMatch.home_team._id}-${existingMatch.away_team._id}-${existingMatch.round._id}`;
        matchesMap.set(matchKey, existingMatch);
      }
    if (
      this.isVisible ||
      (this.competition.stages.find(
        stage => stage.isChosen && stage.category === this.$route.params.cat
      ) &&
        this.matches.filter(
          match =>
            match.stage._id ===
            this.competition.stages.find(
              stage =>
                stage.isChosen && stage.category === this.$route.params.cat
            )._id
        ).length !== checker)
    ) {
      for (const round of this.rounds.filter(
        round => round.category === this.$route.params.cat
      )) {
        for (let i = 0; i < Math.floor(this.teams.length / 2); i++) {
          const homeMatch = {
            home_team: this.teams[i],
            away_team: this.teams[this.teams.length - 1 - i],
            home_players: this.teams[i].players.map(({ player }) => {
              return {
                player: player,
                goals: 0,
                executions: 0,
                drop_goals: 0,
                points: 0,
                cards: []
              };
            }),
            away_players: this.teams[this.teams.length - 1 - i].players.map(
              ({ player }) => {
                return {
                  player: player,
                  goals: 0,
                  executions: 0,
                  drop_goals: 0,
                  points: 0,
                  cards: []
                };
              }
            ),
            stage: this.competition.stages.find(
              stage =>
                (stage.isChosen ? stage.isChosen : stage.isCurrent) &&
                stage.category === this.$route.params.cat
            ),
            round: round
          };

          const homeMatchKey = `${homeMatch.home_team._id}-${homeMatch.away_team._id}-${homeMatch.round._id}`;
          if (!matchesMap.has(homeMatchKey)) {
            matchesMap.set(homeMatchKey, homeMatch);
          }
        }
        this.teams.length % 2 === 0
          ? this.teams.splice(1, 0, this.teams.pop())
          : this.teams.splice(0, 0, this.teams.pop());
      }
    }
    this.updateMatches(Array.from(matchesMap.values()));
  },
  checkForPairMatches() {
    let checker = 0;
    if (this.teams.length % 2 === 0) {
      checker =
        this.teams.length *
        this.rounds.filter(round => round.category === this.$route.params.cat)
          .length;
    } else {
      checker =
        (this.teams.length - 1) *
        this.rounds.filter(round => round.category === this.$route.params.cat)
          .length;
    }
    const matchesArray = [];
    const matchesMap = new Map();
    if (this.matches.length) {
      for (const existingMatch of this.matches) {
        const matchKey = `${existingMatch.home_team._id}-${existingMatch.away_team._id}-${existingMatch.round._id}`;
        const awayMatchKey = `${existingMatch.away_team._id}-${existingMatch.home_team._id}-${existingMatch.round._id}`;
        if (matchesMap.has(awayMatchKey)) {
          matchesArray.find(
            match => match.home.home_team._id === existingMatch.away_team._id
          ).away = existingMatch;
        }
        if (!matchesMap.has(matchKey)) {
          matchesMap.set(matchKey, existingMatch);
          matchesArray.push({ home: existingMatch, away: null, key: matchKey });
        }
      }
    }
    if (
      this.isVisible ||
      (this.competition.stages.find(
        stage => stage.isChosen && stage.category === this.$route.params.cat
      ) &&
        this.matches.filter(
          match =>
            match.stage._id ===
            this.competition.stages.find(
              stage =>
                stage.isChosen && stage.category === this.$route.params.cat
            )._id
        ).length !== checker)
    ) {
      for (const round of this.rounds.filter(
        round => round.category === this.$route.params.cat
      )) {
        for (let i = 0; i < Math.floor(this.teams.length / 2); i++) {
          const homeTeam = this.teams[i];
          const awayTeam = this.teams[this.teams.length - 1 - i];

          if (homeTeam !== awayTeam) {
            const matchKey = `${homeTeam._id}-${awayTeam._id}-${round._id}`;
            const awayMatchKey = `${awayTeam._id}-${homeTeam._id}-${round._id}`;

            if (!matchesMap.has(matchKey)) {
              const homeMatch = {
                home_team: homeTeam,
                away_team: awayTeam,
                home_players: homeTeam.players.map(({ player }) => ({
                  player,
                  goals: 0,
                  drop_goals: 0,
                  executions: 0,
                  points: 0,
                  cards: []
                })),
                away_players: awayTeam.players.map(({ player }) => ({
                  player,
                  goals: 0,
                  drop_goals: 0,
                  executions: 0,
                  points: 0,
                  cards: []
                })),
                round: round,
                stage: this.competition.stages.find(
                  stage =>
                    stage.isCurrent && stage.category === this.$route.params.cat
                )
              };
              matchesMap.set(matchKey, homeMatch);
              matchesArray.push({ home: homeMatch, away: null, key: matchKey });
            }
            if (!matchesMap.has(awayMatchKey)) {
              const awayMatch = {
                home_team: awayTeam,
                away_team: homeTeam,
                home_players: awayTeam.players.map(({ player }) => ({
                  player,
                  goals: 0,
                  drop_goals: 0,
                  executions: 0,
                  points: 0,
                  cards: []
                })),
                away_players: homeTeam.players.map(({ player }) => ({
                  player,
                  goals: 0,
                  drop_goals: 0,
                  executions: 0,
                  points: 0,
                  cards: []
                })),
                round: round,
                stage: this.competition.stages.find(
                  stage =>
                    stage.isCurrent && stage.category === this.$route.params.cat
                )
              };

              matchesMap.set(awayMatchKey, awayMatch);
              matchesArray.push({
                home: awayMatch,
                away: null,
                key: awayMatchKey
              });
            }
          }
        }
        this.teams.length % 2 === 0
          ? this.teams.splice(1, 0, this.teams.pop())
          : this.teams.splice(0, 0, this.teams.pop());
      }
    }
    let resultArray = [];
    const copyMap = new Map(JSON.parse(JSON.stringify(Array.from(matchesMap))));
    copyMap.forEach((value, key) => {
      const [homeId, awayId, roundId] = key.split("-");
      const swappedKey = `${awayId}-${homeId}-${roundId}`;
      if (copyMap.has(swappedKey)) {
        const home = value;
        const away = copyMap.get(swappedKey);
        resultArray.push({ home, away });
        copyMap.delete(key);
        copyMap.delete(swappedKey);
      }
    });
    this.circuitMatches = resultArray;
    this.updateMatches(Array.from(matchesMap.values()));
  },
  async openModal(match) {
    if ((this.partAccess && match.isFinished) || !this.partAccess) {
      if (match.home_team && match.away_team) {
        await this.getDisqualified(match);
        if (!this.isVisible) {
          if (this.competitionIsOngoing) {
            !this.competition.stages.filter(
              stage =>
                stage.isChosen && stage.category === this.$route.params.cat
            ).length
              ? await this.getAllMatches([
                  this.competition.stages.find(
                    stage =>
                      stage.isCurrent &&
                      stage.category === this.$route.params.cat
                  )
                ])
              : await this.getAllMatches([
                  this.competition.stages.find(
                    stage =>
                      stage.isChosen &&
                      stage.category === this.$route.params.cat
                  )
                ]);
          }
          if (this.spec === "twoway") this.checkForPairMatches();
        }
        const updatedMatch = this.matches.find(m => m._id === match._id);
        this.circuitModal = true;
        this.selectedMatch = updatedMatch;
      }
    } else {
      console.log("openModal");
    }
  },
  async openPlayoffModal(match, arr) {
    if ((this.partAccess && match.isFinished) || !this.partAccess) {
      if (match.home_team && match.away_team) {
        await this.getDisqualified(match);
        if (!this.isVisible) {
          if (this.competitionIsOngoing) {
            !this.competition.stages.filter(
              stage =>
                stage.isChosen && stage.category === this.$route.params.cat
            ).length
              ? await this.getAllMatches([
                  this.competition.stages.find(
                    stage =>
                      stage.isCurrent &&
                      stage.category === this.$route.params.cat
                  )
                ])
              : await this.getAllMatches([
                  this.competition.stages.find(
                    stage =>
                      stage.isChosen &&
                      stage.category === this.$route.params.cat
                  )
                ]);
          }
          if (this.spec === "twoway") this.checkForPairMatches();
        }
        const updatedMatch = arr.find(m => m._id === match._id);
        this.circuitModal = true;
        this.selectedMatch = updatedMatch;
      }
    } else {
      console.log("openPlayoffModal");
    }
  },
  async getPlayoffMatches(arg) {
    try {
      let result = [];
      const res = await this.$http.post("/match/getManyFromPlayoff", {
        stages:
          !this.competition.stages.filter(stage => stage.isChosen) &&
          stage.category === this.$route.params.cat.length
            ? this.competition.stages.filter(
                stage =>
                  stage.isCurrent && stage.category === this.$route.params.cat
              )
            : this.competition.stages.filter(
                stage =>
                  stage.isChosen && stage.category === this.$route.params.cat
              ),
        category: this.$route.params.cat
      });
      result.push(...res.data);
      if (arg === "ladder") {
        this.ladder = result;
      } else if (arg === "wildcard") {
        this.playoffs = result;
      } else if (arg === "single") {
        this.playoffs = result;
      }
    } catch (error) {
      console.log(error);
    }
  },
  displayPlus(scored, conceded) {
    let diff = scored - conceded;
    if (diff > 0) {
      return "+" + diff;
    } else {
      return diff;
    }
  },
  onRemote(input) {
    console.log(input);
  },
  onGroupForm(team, group) {
    console.log(team, group);
  },
  blockSave() {
    this.canSave = false;
  },
  async updateTeamsGroups() {
    this.updateLocalGroups();
    let stageCheck = this.competition.stages.find(
      stage => stage.isChosen && stage.category === this.$route.params.cat
    );
    try {
      for (let i = 0; i < this.groups.length; i++) {
        const element = this.groups[i];
        for (let j = 0; j < element.length; j++) {
          const el = element[j];
          if (
            el.group
              .find(({ stage }) => stage === stageCheck._id)
              .hasOwnProperty("index")
          ) {
            const res = await this.$http.post("/team/editGroup", {
              _id: el._id,
              group: el.group.find(({ stage }) => stage === stageCheck._id)
            });
            if (res.data) {
              if (this.sizeOfBrackets) this.canSave = true;
            }
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  },
  async updateTeamStages(team) {
    try {
      await this.$http.post("/team/edit", {
        _id: team._id,
        group: team.group
      });
    } catch (error) {
      console.log(error);
    }
  },
  updateLocalGroups() {
    try {
      let stageCheck = this.competition.stages.find(
        stage => stage.isChosen && stage.category === this.$route.params.cat
      )._id;
      for (let i = 0; i < this.groups.length; i++) {
        const element = this.groups[i];
        for (let j = 0; j < element.length; j++) {
          const el = element[j];
          if (el.group.find(({ stage }) => stage === stageCheck))
            this.groups[i][j].group.find(
              ({ stage }) => stage === stageCheck
            ).index = i;
        }
      }
    } catch (error) {
      console.log(error);
    }
  },
  async generateRoundRobinSchedule() {
    const schedule = [];
    const totalRounds = this.rounds.filter(
      round => round.category === this.$route.params.cat && !round.isPlayoff
    ).length;
    for (let currentRound = 0; currentRound < totalRounds; currentRound++) {
      this.groups.forEach(group => {
        const matchesInGroup = this.generateMatchesInGroup(
          group,
          this.rounds.filter(
            round =>
              round.category === this.$route.params.cat && !round.isPlayoff
          )[currentRound]
        );
        group.length % 2 === 0
          ? group.splice(1, 0, group.pop())
          : group.splice(0, 0, group.pop());
        schedule.push(...matchesInGroup);
      });
    }
    this.updateMatches(schedule);
  },
  getLetter(num) {
    var letter = String.fromCharCode(num + 64);
    return letter;
  },
  generateMatchesInGroup(group, round) {
    const matches = [];
    for (let i = 0; i < group.length / 2; i++) {
      if (group[i]._id !== group[group.length - 1 - i]._id) {
        const match = {
          home_team: group[i],
          away_team: group[group.length - 1 - i],
          home_players: group[i].players.map(({ player }) => {
            return {
              player: player,
              goals: 0,
              drop_goals: 0,
              executions: 0,
              points: 0,
              cards: []
            };
          }),
          away_players: group[group.length - 1 - i].players.map(
            ({ player }) => {
              return {
                player: player,
                goals: 0,
                drop_goals: 0,
                executions: 0,
                points: 0,
                cards: []
              };
            }
          ),
          stage: this.competition.stages.find(
            stage =>
              stage.isCurrent && stage.category === this.$route.params.cat
          ),
          round: round
        };
        matches.push(match);
      }
    }

    return matches;
  },
  closestPowerOfTwo(number, bound) {
    if ((number & (number - 1)) === 0) {
      return number;
    } else {
      let power = 1;
      while (power < number) {
        power *= 2;
      }
      if (bound === "upper") return power;
      else if (bound === "lower") return power / 2;
    }
    return 0;
  },
  formMatch(
    placement,
    home_team,
    away_team,
    playoffStage,
    bracketIndex,
    isUpperBracket
  ) {
    const match = {
      playoffStage: playoffStage,
      home_team: home_team,
      away_team: away_team,
      home_players:
        home_team &&
        home_team.players.map(({ player }) => {
          return {
            player: player,
            goals: 0,
            drop_goals: 0,
            executions: 0,
            points: 0,
            cards: []
          };
        }),
      away_players:
        away_team &&
        away_team.players.map(({ player }) => {
          return {
            player: player,
            goals: 0,
            drop_goals: 0,
            executions: 0,
            points: 0,
            cards: []
          };
        }),
      round: this.competition.stages
        .find(
          stage => stage.isCurrent && stage.category === this.$route.params.cat
        )
        .rounds.find(
          round => round.isPlayoff && round.category === this.$route.params.cat
        ),
      stage: this.competition.stages.find(
        stage => stage.isCurrent && stage.category === this.$route.params.cat
      ),
      isFinished: false,
      placement: placement,
      bracketIndex: bracketIndex,
      isUpperBracket: isUpperBracket
    };
    return match;
  },
  formGroups() {
    const teamsCopy = [
      ...this.teams.sort((a, b) =>
        a.group.find(({ stage }) => {
          let neededStage = this.competition.stages
            .filter(stage => stage.category === this.$route.params.cat)
            .find(({ isChosen }) => isChosen);
          return stage.toString() === neededStage._id.toString();
        }) >
        b.group.find(({ stage }) => {
          let neededStage = this.competition.stages
            .filter(stage => stage.category === this.$route.params.cat)
            .find(({ isChosen }) => isChosen);
          return stage.toString() === neededStage._id.toString();
        })
          ? 1
          : -1
      )
    ];
    const totalTeams = teamsCopy.length;
    const groupSize = Math.ceil(totalTeams / parseInt(this.qty));
    const group = [];
    if (!this.isDraggable) {
      for (let i = 0; i < Array.from(Array(parseInt(this.qty))).length; i++) {
        let currentGroup = [];
        for (let j = 0; j < teamsCopy.length; j++) {
          const element = teamsCopy[j];
          if (
            element.group.find(
              ({ stage }) =>
                stage.toString() ===
                this.competition.stages
                  .find(({ isChosen }) => isChosen)
                  ._id.toString()
            ).index === i
          )
            currentGroup.push(element);
        }
        group.push(currentGroup);
      }
    } else {
      while (teamsCopy.length > 0) {
        group.push(teamsCopy.splice(0, groupSize));
      }
    }
    this.groups = JSON.parse(
      JSON.stringify(group.map(item => this.sortByStageStats(item)))
    );
  },
  formTwoDimensionalMatchArray() {
    this.matchesByGroups = [];
    for (let j = 0; j < this.groups.length; j++) {
      this.matchesByGroups.push(
        this.matches
          .sort((a, b) => {
            return new Date(a.created_at) - new Date(b.created_at);
          })
          .filter(match => {
            let neededStage = this.competition.stages.find(
              stage =>
                (stage.isChosen ? stage.isChosen : stage.isCurrent) &&
                stage.category.toString() === this.$route.params.cat.toString()
            );
            let homeCheck = match.home_team.group.find(
              ({ stage }) => neededStage && stage === neededStage._id
            );
            let awayCheck = match.away_team.group.find(
              ({ stage }) => neededStage && stage === neededStage._id
            );
            if (homeCheck && awayCheck)
              return homeCheck.index === j && awayCheck.index === j;
          })
      );
    }
  },
  addPlayoffMatchesBySOB() {
    const bracketsToReturn = [];
    const groupsCopy = JSON.parse(
      JSON.stringify([...this.groups.map(el => [...el])])
    );
    for (let k = 0; k < this.teams.length / this.sizeOfBrackets; k++) {
      const playoffBracketArray = [];
      if (this.sizeOfBrackets % groupsCopy.length === 0) {
        for (let i = 0; i < this.sizeOfBrackets / groupsCopy.length; i++) {
          for (let j = 0; j < groupsCopy.length; j++) {
            const element = groupsCopy[j][0];
            playoffBracketArray.push(element);
            groupsCopy[j].splice(0, 1);
          }
        }
      } else {
        for (var j = 0; j < groupsCopy.length; j++) {
          let group = this.sortByStageStats(groupsCopy[j]);
          playoffBracketArray.push(group[0]);
          groupsCopy[j].shift();
        }
        let arr = [];
        let blea = 0;
        for (var j = 0; j < groupsCopy.length; j++) {
          let group = this.sortByStageStats(groupsCopy[j]);
          if (group[0]) arr.push({ index: blea, ...group[0] });
          blea++;
        }

        arr = this.sortByStageStats(arr);
        if (arr.length) {
          playoffBracketArray.push(groupsCopy[arr[0].index][0]);
          groupsCopy[arr[0].index].shift();
        }
      }
      bracketsToReturn.push(playoffBracketArray.filter(el => el));
    }
    return bracketsToReturn;
  },
  createFirstStageMatches(arr, index) {
    let initialArrayLength = JSON.parse(JSON.stringify(arr.length));
    let placement = "quarterfinal";
    if (initialArrayLength === 2) {
      placement = "final";
    } else if (initialArrayLength <= 4) {
      placement = "semifinal";
    } else if (initialArrayLength > 4) {
      placement = "quarterfinal";
    }
    if (arr.length >= 2) {
      if (arr.length > 2 && (arr.length / this.groups.length) % 2 !== 0) {
        const oneStageForward = arr.splice(
          0,
          this.sizeOfBrackets -
            this.closestPowerOfTwo(this.sizeOfBrackets, "lower")
        );
        for (let i = 0; i < oneStageForward.length; i++) {
          const element = oneStageForward[i];
          this.playoffs.push(
            this.formMatch("semifinal", element, null, 2, index, true)
          );
        }
      }
      for (let i = 0; i < arr.length / 2; i++) {
        this.playoffs.push(
          this.formMatch(
            placement,
            arr[i],
            arr[arr.length - i - 1],
            1,
            index,
            true
          )
        );
      }
    }
  },
  findWinner(match) {
    return this.getPoints(match.home_players, match, match.home_team) >
      this.getPoints(match.away_players, match, match.away_team)
      ? match.home_team
      : match.away_team;
  },
  findLoser(match) {
    return this.getPoints(match.home_players, match, match.home_team) <
      this.getPoints(match.away_players, match, match.away_team)
      ? match.home_team
      : match.away_team;
  },
  checkIfUpperBracket(placement, isUpperBracket, isWinner) {
    if (placement === "quarterfinal" && isUpperBracket && !isWinner) {
      return false;
    } else if (isUpperBracket) {
      return true;
    }
    return false;
  },
  async editMatch(match) {
    try {
      const res = await this.$http.post("match/edit", match);
    } catch (error) {
      console.log(error);
    }
  },
  createFurtherMatches(arr) {
    const placementSchema = ["quarterfinal", "semifinal", "final"];
    let nextStageWinnerMatches = [];
    let nextStageLoserMatches = [];
    let upwardSemifinals = [...this.playoffs.filter(match => !match.away_team)];
    let winners = [];
    let losers = [];
    for (let i = 0; i < arr.length; i++) {
      const element = arr[i];
      let currentPlacement = placementSchema.findIndex(
        el => element.placement === el
      );
      winners.push({
        team: this.findWinner(element),
        placement: currentPlacement,
        bracketIndex: element.bracketIndex,
        playoffStage: element.playoffStage + 1,
        isUpperBracket: element.isUpperBracket
      });
      if (winners.length === 2 && upwardSemifinals.length) {
        upwardSemifinals[0].away_team = winners[0].team;
        upwardSemifinals[0].away_players = winners[0].team.players.map(
          ({ player }) => {
            return {
              player: player,
              goals: 0,
              executions: 0,
              drop_goals: 0,
              points: 0,
              cards: []
            };
          }
        );
        upwardSemifinals[1].away_team = winners[1].team;
        upwardSemifinals[1].away_players = winners[1].team.players.map(
          ({ player }) => {
            return {
              player: player,
              goals: 0,
              executions: 0,
              drop_goals: 0,
              points: 0,
              cards: []
            };
          }
        );
        for (let i = 0; i < upwardSemifinals.length; i++) {
          const element = upwardSemifinals[i];
          this.editMatch(element);
        }
        winners = [];
      }
      if (winners.length === 2) {
        for (let i = 0; i < winners.length / 2; i++) {
          const home_team = winners[i];
          const away_team = winners[winners.length - 1 - i];
          nextStageWinnerMatches.push(
            this.formMatch(
              placementSchema[home_team.placement + 1],
              home_team.team,
              away_team.team,
              home_team.playoffStage,
              home_team.bracketIndex,
              this.checkIfUpperBracket(
                placementSchema[home_team.placement],
                home_team.isUpperBracket,
                true
              )
            )
          );
        }
        winners = [];
      }
      losers.push({
        team: this.findLoser(element),
        placement: currentPlacement,
        bracketIndex: element.bracketIndex,
        playoffStage: element.playoffStage - 1,
        isUpperBracket: element.isUpperBracket
      });
      if (losers.length === 2) {
        for (let i = 0; i < losers.length / 2; i++) {
          const home_team = losers[i];
          const away_team = losers[losers.length - 1 - i];
          nextStageLoserMatches.push(
            this.formMatch(
              placementSchema[home_team.placement],
              home_team.team,
              away_team.team,
              home_team.playoffStage,
              home_team.bracketIndex,
              this.checkIfUpperBracket(
                placementSchema[home_team.placement],
                home_team.isUpperBracket,
                false
              )
            )
          );
        }
        losers = [];
      }
    }

    this.playoffs.push(...nextStageWinnerMatches, ...nextStageLoserMatches);
  },
  async addPlayoffsToDB() {
    try {
      const DBMatches = await this.$http.post(
        "/match/addMany",
        this.playoffs.filter(match => !match.isFinished && !match._id)
      );
      await this.getCurrentCompetition(false);
    } catch (error) {
      console.log(error);
    }
  },
  async getRealPlayoffMatches() {
    let result = [];
    try {
      const res = await this.$http.post("/match/getManyFromPlayoff", {
        stages: !this.competition.stages.filter(
          stage => stage.isChosen && stage.category === this.$route.params.cat
        ).length
          ? this.competition.stages.filter(
              stage =>
                stage.isCurrent && stage.category === this.$route.params.cat
            )
          : this.competition.stages.filter(
              stage =>
                stage.isChosen && stage.category === this.$route.params.cat
            ),
        category: this.$route.params.cat
      });
      result.push(...res.data);

      this.playoffs = result;
      if (this.playoffs.length) {
        this.formBrackets();
      }
    } catch (error) {
      console.log(error);
    }
  },
  formBrackets() {
    const playoffsCopy = JSON.parse(
      JSON.stringify([
        ...this.playoffs.sort((a, b) => a.bracketIndex - b.bracketIndex)
      ])
    );
    const bracket = [];
    let iteration = Math.ceil(this.teams.length / this.sizeOfBrackets);
    for (let i = 0; i < iteration; i++) {
      bracket.push(
        playoffsCopy.filter(
          match => match.bracketIndex.toString() === i.toString()
        )
      );
    }
    this.brackets = JSON.parse(JSON.stringify([...bracket]));
  },
  getTeamWithHighestScore(a, b, c) {
    if (a.statistics.points > b.statistics.points) {
      if (a.statistics.points > c.statistics.points) {
        return a;
      } else if (a.statistics.points < c.statistics.points) {
        return c;
      } else {
        return a.statistics.scored - a.statistics.conceded >
          c.statistics.scored - c.statistics.conceded
          ? a
          : c;
      }
    } else if (a.statistics.points < b.statistics.points) {
      if (b.statistics.points > c.statistics.points) {
        return b;
      } else if (b.statistics.points < c.statistics.points) {
        return c;
      } else {
        return b.statistics.scored - b.statistics.conceded >
          c.statistics.scored - c.statistics.conceded
          ? b
          : c;
      }
    } else {
      let decider =
        a.statistics.scored - a.statistics.conceded >
        b.statistics.scored - b.statistics.conceded
          ? a
          : b;
      if (decider.statistics.points > c.statistics.points) {
        return decider;
      } else if (decider.statistics.points < c.statistics.points) {
        return c;
      } else {
        return decider.statistics.scored - decider.statistics.conceded >
          c.statistics.scored - c.statistics.conceded
          ? decider
          : c;
      }
    }
  },
  getDecider(a, b) {
    if (a.statistics.points > b.statistics.points) {
      return a;
    } else if (a.statistics.points < b.statistics.points) {
      return b;
    } else {
      return a.statistics.scored - a.statistics.conceded >
        b.statistics.scored - b.statistics.conceded
        ? a
        : b;
    }
  },
  sortByTotalStats(a, b) {
    if (a.statistics && b.statistics) {
      if (
        // a.statistics.totalPoints &&
        // b.statistics.totalPoints &&
        a.statistics.totalPoints !== b.statistics.totalPoints
      ) {
        console.log("1");
        return b.statistics.totalPoints - a.statistics.totalPoints;
      }
      if (
        a.statistics.totalScored - a.statistics.totalConceded !==
        b.statistics.totalScored - b.statistics.totalConceded
      ) {
        console.log("2");
        return (
          b.statistics.totalScored -
          b.statistics.totalConceded -
          (a.statistics.totalScored - a.statistics.totalConceded)
        );
      }
      if (a.statistics.totalScored !== b.statistics.totalScored) {
        console.log("3");
        return b.statistics.totalScored - a.statistics.totalScored;
      }
    }
    if (a.name && b.name) {
      return a.name.localeCompare(b.name);
    }
    return 0;
  },
  sortByStageStats(teams, trueSort) {
    if (this.competition) {
      this.currentStageIndex = this.competition.stages
        .filter(stage => stage.category === this.$route.params.cat)
        .findIndex(stage =>
          stage.isChosen ? stage.isChosen : stage.isCurrent
        );
      if (
        this.type === "group" &&
        trueSort &&
        this.playoffs.every(match => match.isFinished)
      ) {
        teams.forEach(async team => {
          let standings = this.getStandings(this.playoffs);
          if (standings.length) {
            standings.push(
              ...teams.filter(
                team => !standings.some(standing => standing._id === team._id)
              )
            );
            standings.forEach(
              place =>
                (place.rating = standings.length - standings.indexOf(place))
            );
            let stand = standings.find(standing => standing._id === team._id);
            if (stand)
              team.statistics.stages[this.currentStageIndex].points =
                stand.rating;
          }
        });
      }
    }
    return teams.sort((a, b) => {
      if (a.statistics && b.statistics) {
        let aStage = a.statistics.stages[this.currentStageIndex];
        let bStage = b.statistics.stages[this.currentStageIndex];
        if (aStage.points !== bStage.points) {
          return bStage.points - aStage.points;
        }
        const goalDiffA = aStage.scored - aStage.conceded;
        const goalDiffB = bStage.scored - bStage.conceded;
        if (goalDiffA !== goalDiffB) {
          return goalDiffB - goalDiffA;
        }

        if (aStage.scored !== bStage.scored) {
          return bStage.scored - aStage.scored;
        }
        return this.sortByTotalStats(a, b);
      }
      return 0;
    });
  },
  sortByCertainStageStats(teams, myStage, cat) {
    if (this.competition) {
      let arbitraryIndex = this.competition.stages.find(
        stage => stage.category === cat && stage._id === myStage
      );
      console.log({ arbitraryIndex, myStage });
      return teams.sort((a, b) => {
        if (a.statistics && b.statistics) {
          let aStage = a.statistics.stages.find(
            stag => stag.stage._id === arbitraryIndex._id
          );
          let bStage = b.statistics.stages.find(
            stag => stag.stage._id === arbitraryIndex._id
          );
          if (aStage.pts !== bStage.pts) {
            return bStage.pts - aStage.pts;
          }
          const goalDiffA = aStage.scored - aStage.conceded;
          const goalDiffB = bStage.scored - bStage.conceded;
          if (goalDiffA !== goalDiffB) {
            return goalDiffB - goalDiffA;
          }
          if (aStage.scored !== bStage.scored) {
            return bStage.scored - aStage.scored;
          }
          return this.sortByTotalStats(a, b);
        }
        return 0;
      });
    }
  },
  async goToPlayoffs() {
    if (this.matches.length && this.matches.every(match => match.isFinished)) {
      this.groupStageFinished = true;
    }
  },
  getWidth() {
    let widthHeader = $(".main-content")[0];
    let resizeObserver = new ResizeObserver(widthEl => {
      if (widthEl[0].contentRect.width > 1400) {
        this.spanCount = "6";
      } else {
        this.spanCount = "12";
      }
    });
    resizeObserver.observe(widthHeader);
  },
  async finishCompetition() {
    try {
      await this.$http.post("/competition/finish", {
        _id: this.competition._id
      });
      window.location.reload();
    } catch (error) {
      console.log(error);
    }
  },
  disableFor(arr) {
    if (!this.$user.data.role) return false;
    return !arr.includes(this.$user.data.role[0]);
  },
  enableFor(arr) {
    if (!this.$user.data.role) return false;
    return arr.includes(this.$user.data.role[0]);
  },
  formStandings(element, destArray) {
    if (
      this.getPoints(element.home_players, element, element.home_team) >
      this.getPoints(element.away_players, element, element.away_team)
    ) {
      if (!destArray.some(team => team._id === element.home_team._id))
        destArray.push(element.home_team);
      if (!destArray.some(team => team._id === element.away_team._id))
        destArray.push(element.away_team);
    } else {
      if (!destArray.some(team => team._id === element.away_team._id))
        destArray.push(element.away_team);
      if (!destArray.some(team => team._id === element.home_team._id))
        destArray.push(element.home_team);
    }
  },
  async getStandingsByStage(stages) {
    let stageMatches = [];
    try {
      const res = await this.$http.post("/match/getManyFromPlayoff", {
        stages: stages,
        category: this.$route.params.cat
      });
      stageMatches.push(...res.data);
    } catch (error) {
      console.log(error);
    }
    return this.getStandings(stageMatches);
  },
  getStandings(matchList, destArray) {
    let playoffs;
    if (!matchList) playoffs = this.playoffs;
    else playoffs = matchList;
    if (playoffs.every(match => match.isFinished)) {
      let neededPlayoffMatches = [...playoffs].filter(match => {
        let neededFinal = playoffs.find(
          final =>
            final.placement === "final" &&
            final.bracketIndex === match.bracketIndex
        );
        if (match.placement === "semifinal") {
          return match.playoffStage === neededFinal.playoffStage - 2;
        } else if (match.placement === "quarterfinal") {
          return match.playoffStage < 0;
        } else {
          return match;
        }
      });
      for (let i = 0; i < neededPlayoffMatches.length; i++) {
        const element = neededPlayoffMatches[i];

        const placementSchema = ["quarterfinal", "semifinal", "final"];
        neededPlayoffMatches[i].rating =
          placementSchema.indexOf(element.placement) +
          +element.isUpperBracket +
          element.playoffStage -
          element.bracketIndex * 10;
      }
      if (!destArray) {
        let testArray = [];
        let ratedPlayoffs = neededPlayoffMatches.sort((a, b) =>
          a.rating > b.rating ? -1 : 1
        );
        for (let i = 0; i < ratedPlayoffs.length; i++) {
          const element = ratedPlayoffs[i];
          this.formStandings(element, testArray);
        }
        return testArray;
      }
      let ratedPlayoffs = neededPlayoffMatches.sort((a, b) =>
        a.rating > b.rating ? -1 : 1
      );
      for (let i = 0; i < ratedPlayoffs.length; i++) {
        const element = ratedPlayoffs[i];
        this.formStandings(element, destArray);
      }
    }
  },
  getFinalStandings() {
    this.getStandings(this.playoffs, this.standings);
    // let extras = this.teams.filter((team) => !this.standings.some(standing => standing._id === team._id))
    this.standings.push(
      ...this.teams.filter(
        team => !this.standings.some(standing => standing._id === team._id)
      )
    );

    this.standings.forEach(
      place =>
        (place.rating = this.standings.length - this.standings.indexOf(place))
    );
  }
  // getFinalStandings(arg) {
  //   if (this.standings.length !== this.teams.length) {
  //     if (arg === "ladder") {
  //       this.ladder.forEach(element => this.formStandings(element));
  //     } else if (arg === "wildcard") {
  //       if (this.groups.length === 2) {
  //         this.playoffs.forEach(element => {
  //           if (element.playoffStage === 3) this.formStandings(element);
  //         });
  //         this.playoffs.forEach(element => {
  //           if (element.playoffStage === 2.5) this.formStandings(element);
  //         });
  //         this.playoffs.forEach(element => {
  //           if (element.playoffStage === 0.5) this.formStandings(element);
  //         });
  //         this.playoffs.forEach(element => {
  //           if (element.playoffStage === -3) this.formStandings(element);
  //         });
  //         this.playoffs.forEach(element => {
  //           if (element.playoffStage === -2.5) this.formStandings(element);
  //         });
  //         this.playoffs.forEach(element => {
  //           if (element.playoffStage === -0.5) this.formStandings(element);
  //         });
  //         if (this.groups.every(group => group.length === 4)) {
  //           this.playoffs.forEach(element => {
  //             if (element.playoffStage === -1) this.formStandings(element);
  //           });
  //         }
  //         const teamsOnlyInGroups = this.groups.flat().filter(teamInGroups =>
  //           !this.standings.some(teamInStandings => teamInStandings._id === teamInGroups._id)
  //         ).sort(this.sortByTotalStats);
  //         if (teamsOnlyInGroups.length)
  //           this.standings.push(...teamsOnlyInGroups)
  //       }
  //       if (this.groups.length === 4) {
  //         this.playoffs.forEach(element => {
  //           if (element.playoffStage === 4) this.formStandings(element);
  //         });
  //         this.playoffs.forEach(element => {
  //           if (element.playoffStage === 3.5) this.formStandings(element);
  //         });
  //         this.playoffs.forEach(element => {
  //           if (element.playoffStage === 2.75) this.formStandings(element);
  //         });
  //         this.playoffs.forEach(element => {
  //           if (element.playoffStage === 2.25) this.formStandings(element);
  //         });
  //         this.playoffs.forEach(element => {
  //           if (element.playoffStage === 1.5) this.formStandings(element);
  //         });
  //         this.playoffs.forEach(element => {
  //           if (element.playoffStage === 1.25) this.formStandings(element);
  //         });
  //         this.playoffs.forEach(element => {
  //           if (element.playoffStage === -4) this.formStandings(element);
  //         });
  //         this.playoffs.forEach(element => {
  //           if (element.playoffStage === -3.5) this.formStandings(element);
  //         });
  //         this.playoffs.forEach(element => {
  //           if (element.playoffStage === -2.75) this.formStandings(element);
  //         });
  //         this.playoffs.forEach(element => {
  //           if (element.playoffStage === -2.25) this.formStandings(element);
  //         });
  //         this.playoffs.forEach(element => {
  //           if (element.playoffStage === -1.5) this.formStandings(element);
  //         });
  //         this.playoffs.forEach(element => {
  //           if (element.playoffStage === -1.25) this.formStandings(element);
  //         });
  //       }
  //     } else if (
  //       arg === "single" &&
  //       (this.groups.length === 2 || this.groups.length === 3)
  //     ) {
  //       this.playoffs.forEach(element => {
  //         if (element.playoffStage === 2) this.formStandings(element);
  //       });
  //       this.playoffs.forEach(element => {
  //         if (element.playoffStage === 1.5) this.formStandings(element);
  //       });
  //       if (this.groups.length === 3) {
  //         this.playoffs.forEach(element => {
  //           if (element.playoffStage === 0.5) this.formStandings(element);
  //         });
  //       }
  //       this.playoffs.forEach(element => {
  //         if (element.playoffStage === -2) this.formStandings(element);
  //       });
  //       this.playoffs.forEach(element => {
  //         if (element.playoffStage === -1.5) this.formStandings(element);
  //       });
  //       if (this.groups.length === 3) {
  //         this.playoffs.forEach(element => {
  //           if (element.playoffStage === -0.5) this.formStandings(element);
  //         });
  //       }
  //     } else if (arg === "single" && this.groups.length === 4) {
  //       this.playoffs.forEach(element => {
  //         if (element.playoffStage === 3) this.formStandings(element);
  //       });
  //       this.playoffs.forEach(element => {
  //         if (element.playoffStage === 2.5) this.formStandings(element);
  //       });
  //       this.playoffs.forEach(element => {
  //         if (element.playoffStage === 1.5) this.formStandings(element);
  //       });
  //       this.playoffs.forEach(element => {
  //         if (element.playoffStage === 1.25) this.formStandings(element);
  //       });
  //       this.playoffs.forEach(element => {
  //         if (element.playoffStage === -3) this.formStandings(element);
  //       });
  //       this.playoffs.forEach(element => {
  //         if (element.playoffStage === -2.5) this.formStandings(element);
  //       });
  //       this.playoffs.forEach(element => {
  //         if (element.playoffStage === -1.5) this.formStandings(element);
  //       });
  //       this.playoffs.forEach(element => {
  //         if (element.playoffStage === -1.25) this.formStandings(element);
  //       });
  //     }
  //   }
  // },
  // async previousStage() {
  //   const actIndex = this.competition.stages.findIndex((stage) => stage.isChosen ? stage.isChosen : stage.isCurrent)
  //   localStorage.setItem('chosenStage', this.competition.stages[actIndex - 1]._id)
  //   await this.getUpdatedCompetition();
  //   await this.getExtendedCurrentTeams();
  //   this.currentStageIndex = this.competition.stages.findIndex((stage) => stage.isChosen ? stage.isChosen : stage.isCurrent)
  //   this.listedTeams = this.sortByStageStats(JSON.parse(JSON.stringify([...this.teams])))
  //   if (this.type === 'circuit') {
  //     this.forceRerender()
  //   } else if (this.type === 'group') {
  //     window.location.reload()
  //   }
  // },
  // async nextStage() {
  //   const actIndex = this.competition.stages.findIndex((stage) => stage.isChosen ? stage.isChosen : stage.isCurrent)
  //   localStorage.setItem('chosenStage', this.competition.stages[actIndex + 1]._id)

  //   await this.getUpdatedCompetition();
  //   await this.getExtendedCurrentTeams();
  //   this.currentStageIndex = this.competition.stages.findIndex((stage) => stage.isChosen ? stage.isChosen : stage.isCurrent)
  //   this.listedTeams = this.sortByStageStats(JSON.parse(JSON.stringify([...this.teams])))
  //   if (this.type === 'circuit') {
  //     this.forceRerender()
  //   } else if (this.type === 'group') {
  //     window.location.reload()
  //   }
  // },
  // getSE2Final(playoffMatches, status) {
  //   const group1 = this.groups[0];
  //   const group2 = this.groups[1];
  //   //Final
  //   if (
  //     this.playoffs.length &&
  //     this.playoffs
  //       .filter(match => match.playoffStage === (status ? 1 : -1))
  //       .every(match => match.isFinished)
  //   ) {
  //     let finalist1;
  //     let finalist2;
  //     let match1 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 1 : -1)
  //     )[0];
  //     let match2 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 1 : -1)
  //     )[1];
  //     if (match1 && match2) {
  //       if (
  //         this.getPoints(match1.away_players, match1, match1.away_team) >
  //         this.getPoints(match1.home_players, match1, match1.home_team)
  //       ) {
  //         finalist1 = match1.away_team;
  //       } else {
  //         finalist1 = match1.home_team;
  //       }
  //       if (
  //         this.getPoints(match2.away_players, match2, match2.away_team) >
  //         this.getPoints(match2.home_players, match2, match2.home_team)
  //       ) {
  //         finalist2 = match2.away_team;
  //       } else {
  //         finalist2 = match2.home_team;
  //       }

  //       playoffMatches.push(
  //         this.formMatch("final", finalist1, finalist2, status ? 2 : -2)
  //       );
  //     }
  //   }

  //   //3rd Place
  //   if (
  //     this.playoffs.length &&
  //     this.playoffs
  //       .filter(match => match.playoffStage === (status ? 1 : -1))
  //       .every(match => match.isFinished)
  //   ) {
  //     let challenger1;
  //     let challenger2;
  //     let match1 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 1 : -1)
  //     )[0];
  //     let match2 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 1 : -1)
  //     )[1];
  //     if (match1 && match2) {
  //       if (
  //         this.getPoints(match1.away_players, match1, match1.away_team) <
  //         this.getPoints(match1.home_players, match1, match1.home_team)
  //       ) {
  //         challenger1 = match1.away_team;
  //       } else {
  //         challenger1 = match1.home_team;
  //       }
  //       if (
  //         this.getPoints(match2.away_players, match2, match2.away_team) <
  //         this.getPoints(match2.home_players, match2, match2.home_team)
  //       ) {
  //         challenger2 = match2.away_team;
  //       } else {
  //         challenger2 = match2.home_team;
  //       }

  //       playoffMatches.push(
  //         this.formMatch("final", challenger1, challenger2, status ? 1.5 : -1.5)
  //       );
  //     }
  //   }
  //   playoffMatches.push(
  //     this.formMatch("semifinal",
  //       group1[status ? 0 : 2],
  //       group2[status ? 1 : 3],
  //       status ? 1 : -1
  //     )
  //   );
  //   playoffMatches.push(
  //     this.formMatch("semifinal",
  //       group2[status ? 0 : 2],
  //       group1[status ? 1 : 3],
  //       status ? 1 : -1
  //     )
  //   );
  // },
  // getSE24GroupsFinal(playoffMatches, status) {
  //   const group1 = this.groups[0];
  //   const group2 = this.groups[1];
  //   const group3 = this.groups[2];
  //   const group4 = this.groups[3];
  //   //Final
  //   if (
  //     this.playoffs.length &&
  //     this.playoffs
  //       .filter(match => match.playoffStage === (status ? 1 : -1))
  //       .every(match => match.isFinished)
  //   ) {
  //     let finalist1;
  //     let finalist2;
  //     let match1 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 1 : -1)
  //     )[0];
  //     let match2 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 1 : -1)
  //     )[1];
  //     if (match1 && match2) {
  //       if (
  //         this.getPoints(match1.away_players, match1, match1.away_team) >
  //         this.getPoints(match1.home_players, match1, match1.home_team)
  //       ) {
  //         finalist1 = match1.away_team;
  //       } else {
  //         finalist1 = match1.home_team;
  //       }
  //       if (
  //         this.getPoints(match2.away_players, match2, match2.away_team) >
  //         this.getPoints(match2.home_players, match2, match2.home_team)
  //       ) {
  //         finalist2 = match2.away_team;
  //       } else {
  //         finalist2 = match2.home_team;
  //       }

  //       playoffMatches.push(
  //         this.formMatch("final", finalist1, finalist2, status ? 2 : -2)
  //       );
  //     }
  //   }

  //   //3rd Place
  //   if (
  //     this.playoffs.length &&
  //     this.playoffs
  //       .filter(match => match.playoffStage === (status ? 1 : -1))
  //       .every(match => match.isFinished)
  //   ) {
  //     let challenger1;
  //     let challenger2;
  //     let match1 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 1 : -1)
  //     )[0];
  //     let match2 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 1 : -1)
  //     )[1];
  //     if (match1 && match2) {
  //       if (
  //         this.getPoints(match1.away_players, match1, match1.away_team) <
  //         this.getPoints(match1.home_players, match1, match1.home_team)
  //       ) {
  //         challenger1 = match1.away_team;
  //       } else {
  //         challenger1 = match1.home_team;
  //       }
  //       if (
  //         this.getPoints(match2.away_players, match2, match2.away_team) <
  //         this.getPoints(match2.home_players, match2, match2.home_team)
  //       ) {
  //         challenger2 = match2.away_team;
  //       } else {
  //         challenger2 = match2.home_team;
  //       }

  //       playoffMatches.push(
  //         this.formMatch("final", challenger1, challenger2, status ? 1.5 : -1.5)
  //       );
  //     }
  //   }
  //   playoffMatches.push(
  //     this.formMatch("semifinal",
  //       group1[status ? 0 : 2],
  //       group2[status ? 0 : 2],
  //       status ? 1 : -1
  //     )
  //   );
  //   playoffMatches.push(
  //     this.formMatch("semifinal",
  //       group3[status ? 0 : 2],
  //       group4[status ? 0 : 2],
  //       status ? 1 : -1
  //     )
  //   );
  // },
  // getSE3Final(playoffMatches, status) {
  //   const group1 = this.groups[0];
  //   const group2 = this.groups[1];
  //   const group3 = this.groups[2];
  //   //Final
  //   if (
  //     this.playoffs.length &&
  //     this.playoffs
  //       .filter(match => match.playoffStage === (status ? 1 : -1))
  //       .every(match => match.isFinished)
  //   ) {
  //     let finalist1;
  //     let finalist2;
  //     let match1 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 1 : -1)
  //     )[0];
  //     let match2 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 1 : -1)
  //     )[1];
  //     if (match1 && match2) {
  //       if (
  //         this.getPoints(match1.away_players, match1, match1.away_team) >
  //         this.getPoints(match1.home_players, match1, match1.home_team)
  //       ) {
  //         finalist1 = match1.away_team;
  //       } else {
  //         finalist1 = match1.home_team;
  //       }
  //       if (
  //         this.getPoints(match2.away_players, match2, match2.away_team) >
  //         this.getPoints(match2.home_players, match2, match2.home_team)
  //       ) {
  //         finalist2 = match2.away_team;
  //       } else {
  //         finalist2 = match2.home_team;
  //       }

  //       playoffMatches.push(
  //         this.formMatch("final", finalist1, finalist2, status ? 2 : -2)
  //       );
  //     }
  //   }

  //   //3rd-4th Place Match
  //   if (
  //     this.playoffs.length &&
  //     this.playoffs
  //       .filter(match => match.playoffStage === (status ? 1 : -1))
  //       .every(match => match.isFinished)
  //   ) {
  //     let challenger1;
  //     let challenger2;
  //     let match1 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 1 : -1)
  //     )[0];
  //     let match2 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 1 : -1)
  //     )[1];
  //     if (match1 && match2) {
  //       if (
  //         this.getPoints(match1.away_players, match1, match1.away_team) <
  //         this.getPoints(match1.home_players, match1, match1.home_team)
  //       ) {
  //         challenger1 = match1.away_team;
  //       } else {
  //         challenger1 = match1.home_team;
  //       }
  //       if (
  //         this.getPoints(match2.away_players, match2, match2.away_team) <
  //         this.getPoints(match2.home_players, match2, match2.home_team)
  //       ) {
  //         challenger2 = match2.away_team;
  //       } else {
  //         challenger2 = match2.home_team;
  //       }

  //       playoffMatches.push(
  //         this.formMatch("final", challenger1, challenger2, status ? 1.5 : -1.5)
  //       );
  //     }
  //   }

  //   //5-6th Place Match
  //   const deciders = [
  //     group1[status ? 1 : 3],
  //     group2[status ? 1 : 3],
  //     group3[status ? 1 : 3]
  //   ];
  //   const challengers = deciders.filter(
  //     team => team._id !== this.getTeamWithHighestScore(...deciders)._id
  //   );
  //   let home_challenger;
  //   let away_challenger;
  //   if (this.getDecider(...challengers)._id === challengers[0]._id) {
  //     home_challenger = challengers[0];
  //     away_challenger = challengers[1];
  //   } else {
  //     home_challenger = challengers[1];
  //     away_challenger = challengers[0];
  //   }
  //   playoffMatches.push(
  //     this.formMatch("semifinal", home_challenger, away_challenger, status ? 0.5 : -0.5)
  //   );
  //   //Semifinals
  //   playoffMatches.push(
  //     this.formMatch("semifinal",
  //       group1[status ? 0 : 2],
  //       group2[status ? 0 : 2],
  //       status ? 1 : -1
  //     )
  //   );

  //   playoffMatches.push(
  //     this.formMatch("semifinal",
  //       group3[status ? 0 : 2],
  //       this.getTeamWithHighestScore(...deciders),
  //       status ? 1 : -1
  //     )
  //   );
  // },
  // getSE4Final(playoffMatches, status) {
  //   const group1 = this.groups[0];
  //   const group2 = this.groups[1];
  //   const group3 = this.groups[2];
  //   const group4 = this.groups[3];

  //   //Final
  //   if (
  //     this.playoffs.length &&
  //     this.playoffs
  //       .filter(match => match.playoffStage === (status ? 2 : -2))
  //       .every(match => match.isFinished)
  //   ) {
  //     let finalist1;
  //     let finalist2;
  //     let match1 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 2 : -2)
  //     )[0];
  //     let match2 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 2 : -2)
  //     )[1];
  //     if (match1 && match2) {
  //       if (
  //         this.getPoints(match1.away_players, match1, match1.away_team) >
  //         this.getPoints(match1.home_players, match1, match1.home_team)
  //       ) {
  //         finalist1 = match1.away_team;
  //       } else {
  //         finalist1 = match1.home_team;
  //       }
  //       if (
  //         this.getPoints(match2.away_players, match2, match2.away_team) >
  //         this.getPoints(match2.home_players, match2, match2.home_team)
  //       ) {
  //         finalist2 = match2.away_team;
  //       } else {
  //         finalist2 = match2.home_team;
  //       }
  //       playoffMatches.push(
  //         this.formMatch("final", finalist1, finalist2, status ? 3 : -3)
  //       );
  //     }
  //   }
  //   //3rd Place Match
  //   if (
  //     this.playoffs.length &&
  //     this.playoffs
  //       .filter(match => match.playoffStage === (status ? 2 : -2))
  //       .every(match => match.isFinished)
  //   ) {
  //     let challenger1;
  //     let challenger2;
  //     let match1 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 2 : -2)
  //     )[0];
  //     let match2 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 2 : -2)
  //     )[1];
  //     if (match1 && match2) {
  //       if (
  //         this.getPoints(match1.away_players, match1, match1.away_team) <
  //         this.getPoints(match1.home_players, match1, match1.home_team)
  //       ) {
  //         challenger1 = match1.away_team;
  //       } else {
  //         challenger1 = match1.home_team;
  //       }
  //       if (
  //         this.getPoints(match2.away_players, match2, match2.away_team) <
  //         this.getPoints(match2.home_players, match2, match2.home_team)
  //       ) {
  //         challenger2 = match2.away_team;
  //       } else {
  //         challenger2 = match2.home_team;
  //       }
  //       playoffMatches.push(
  //         this.formMatch("final", challenger1, challenger2, status ? 2.5 : -2.5)
  //       );
  //     }
  //   }

  //   //Winner Semifinals
  //   if (
  //     this.playoffs.length &&
  //     this.playoffs
  //       .filter(match => match.playoffStage === (status ? 1 : -1))
  //       .every(match => match.isFinished)
  //   ) {
  //     let semifinalist1;
  //     let semifinalist2;
  //     let semifinalist3;
  //     let semifinalist4;
  //     let match1 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 1 : -1)
  //     )[0];
  //     let match2 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 1 : -1)
  //     )[1];
  //     let match3 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 1 : -1)
  //     )[2];
  //     let match4 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 1 : -1)
  //     )[3];
  //     if (match1 && match2) {
  //       if (
  //         this.getPoints(match1.away_players, match1, match1.away_team) >
  //         this.getPoints(match1.home_players, match1, match1.home_team)
  //       ) {
  //         semifinalist1 = match1.away_team;
  //       } else {
  //         semifinalist1 = match1.home_team;
  //       }
  //       if (
  //         this.getPoints(match2.away_players, match2, match2.away_team) >
  //         this.getPoints(match2.home_players, match2, match2.home_team)
  //       ) {
  //         semifinalist2 = match2.away_team;
  //       } else {
  //         semifinalist2 = match2.home_team;
  //       }
  //       playoffMatches.push(
  //         this.formMatch("semifinal", semifinalist1, semifinalist2, status ? 2 : -2)
  //       );
  //     }
  //     if (match3 && match4) {
  //       if (
  //         this.getPoints(match3.away_players, match3, match3.away_team) >
  //         this.getPoints(match3.home_players, match3, match3.home_team)
  //       ) {
  //         semifinalist3 = match3.away_team;
  //       } else {
  //         semifinalist3 = match3.home_team;
  //       }
  //       if (
  //         this.getPoints(match4.away_players, match4, match4.away_team) >
  //         this.getPoints(match4.home_players, match4, match4.home_team)
  //       ) {
  //         semifinalist4 = match4.away_team;
  //       } else {
  //         semifinalist4 = match4.home_team;
  //       }

  //       playoffMatches.push(
  //         this.formMatch("semifinal", semifinalist3, semifinalist4, status ? 2 : -2)
  //       );
  //     }
  //   }
  //   //5th Place Match
  //   if (
  //     this.playoffs.length &&
  //     this.playoffs
  //       .filter(match => match.playoffStage === (status ? 0.5 : -0.5))
  //       .every(match => match.isFinished)
  //   ) {
  //     let challenger1;
  //     let challenger2;
  //     let match1 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 0.5 : -0.5)
  //     )[0];
  //     let match2 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 0.5 : -0.5)
  //     )[1];
  //     if (match1 && match2) {
  //       if (
  //         this.getPoints(match1.away_players, match1, match1.away_team) >
  //         this.getPoints(match1.home_players, match1, match1.home_team)
  //       ) {
  //         challenger1 = match1.away_team;
  //       } else {
  //         challenger1 = match1.home_team;
  //       }
  //       if (
  //         this.getPoints(match2.away_players, match2, match2.away_team) >
  //         this.getPoints(match2.home_players, match2, match2.home_team)
  //       ) {
  //         challenger2 = match2.away_team;
  //       } else {
  //         challenger2 = match2.home_team;
  //       }

  //       playoffMatches.push(
  //         this.formMatch("semifinal", challenger1, challenger2, status ? 1.5 : -1.5)
  //       );
  //     }
  //   }
  //   //7th Place Match
  //   if (
  //     this.playoffs.length &&
  //     this.playoffs
  //       .filter(match => match.playoffStage === (status ? 0.5 : -0.5))
  //       .every(match => match.isFinished)
  //   ) {
  //     let challenger1;
  //     let challenger2;
  //     let match1 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 0.5 : -0.5)
  //     )[0];
  //     let match2 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 0.5 : -0.5)
  //     )[1];
  //     if (match1 && match2) {
  //       if (
  //         this.getPoints(match1.away_players, match1, match1.away_team) <
  //         this.getPoints(match1.home_players, match1, match1.home_team)
  //       ) {
  //         challenger1 = match1.away_team;
  //       } else {
  //         challenger1 = match1.home_team;
  //       }
  //       if (
  //         this.getPoints(match2.away_players, match2, match2.away_team) <
  //         this.getPoints(match2.home_players, match2, match2.home_team)
  //       ) {
  //         challenger2 = match2.away_team;
  //       } else {
  //         challenger2 = match2.home_team;
  //       }

  //       playoffMatches.push(
  //         this.formMatch("semifinal", challenger1, challenger2, status ? 1.25 : -1.25)
  //       );
  //     }
  //   }

  //   //Loser Semifinals
  //   if (
  //     this.playoffs.length &&
  //     this.playoffs
  //       .filter(match => match.playoffStage === (status ? 1 : -1))
  //       .every(match => match.isFinished)
  //   ) {
  //     let semifinalist1;
  //     let semifinalist2;
  //     let semifinalist3;
  //     let semifinalist4;
  //     let match1 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 1 : -1)
  //     )[0];
  //     let match2 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 1 : -1)
  //     )[1];
  //     let match3 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 1 : -1)
  //     )[2];
  //     let match4 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 1 : -1)
  //     )[3];
  //     if (match1 && match2) {
  //       if (
  //         this.getPoints(match1.away_players, match1, match1.away_team) <
  //         this.getPoints(match1.home_players, match1, match1.home_team)
  //       ) {
  //         semifinalist1 = match1.away_team;
  //       } else {
  //         semifinalist1 = match1.home_team;
  //       }
  //       if (
  //         this.getPoints(match2.away_players, match2, match2.away_team) <
  //         this.getPoints(match2.home_players, match2, match2.home_team)
  //       ) {
  //         semifinalist2 = match2.away_team;
  //       } else {
  //         semifinalist2 = match2.home_team;
  //       }

  //       playoffMatches.push(
  //         this.formMatch("quarterfinal", semifinalist1, semifinalist2, status ? 0.5 : -0.5)
  //       );
  //     }
  //     if (match3 && match4) {
  //       if (
  //         this.getPoints(match3.away_players, match3, match3.away_team) <
  //         this.getPoints(match3.home_players, match3, match3.home_team)
  //       ) {
  //         semifinalist3 = match3.away_team;
  //       } else {
  //         semifinalist3 = match3.home_team;
  //       }
  //       if (
  //         this.getPoints(match4.away_players, match4, match4.away_team) <
  //         this.getPoints(match4.home_players, match4, match4.home_team)
  //       ) {
  //         semifinalist4 = match4.away_team;
  //       } else {
  //         semifinalist4 = match4.home_team;
  //       }

  //       playoffMatches.push(
  //         this.formMatch("quarterfinal", semifinalist3, semifinalist4, status ? 0.5 : -0.5)
  //       );
  //     }
  //   }
  //   //Quarterfinals
  //   playoffMatches.push(
  //     this.formMatch("quarterfinal",
  //       group1[status ? 0 : 2],
  //       group2[status ? 1 : 3],
  //       status ? 1 : -1
  //     )
  //   );
  //   playoffMatches.push(
  //     this.formMatch("quarterfinal",
  //       group2[status ? 0 : 2],
  //       group1[status ? 1 : 3],
  //       status ? 1 : -1
  //     )
  //   );
  //   playoffMatches.push(
  //     this.formMatch("quarterfinal",
  //       group3[status ? 0 : 2],
  //       group4[status ? 1 : 3],
  //       status ? 1 : -1
  //     )
  //   );
  //   playoffMatches.push(
  //     this.formMatch("quarterfinal",
  //       group4[status ? 0 : 2],
  //       group3[status ? 1 : 3],
  //       status ? 1 : -1
  //     )
  //   );
  // },
  // getWC2Final(playoffMatches, status) {
  //   const group1 = this.groups[0];
  //   const group2 = this.groups[1];
  //   if (
  //     this.playoffs.length &&
  //     this.playoffs
  //       .filter(match => match.playoffStage === (status ? 2 : -2))
  //       .every(match => match.isFinished)
  //   ) {
  //     //FINAL
  //     let finalist1;
  //     let finalist2;
  //     let match1 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 2 : -2)
  //     )[0];
  //     let match2 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 2 : -2)
  //     )[1];
  //     if (match1 && match2) {
  //       if (
  //         this.getPoints(match1.away_players, match1, match1.away_team) >
  //         this.getPoints(match1.home_players, match1, match1.home_team)
  //       ) {
  //         finalist1 = match1.away_team;
  //       } else {
  //         finalist1 = match1.home_team;
  //       }
  //       if (
  //         this.getPoints(match2.away_players, match2, match2.away_team) >
  //         this.getPoints(match2.home_players, match2, match2.home_team)
  //       ) {
  //         finalist2 = match2.away_team;
  //       } else {
  //         finalist2 = match2.home_team;
  //       }

  //       playoffMatches.push(
  //         this.formMatch("final", finalist1, finalist2, status ? 3 : -3)
  //       );
  //     }
  //   }
  //   if (
  //     this.playoffs.length &&
  //     this.playoffs
  //       .filter(match => match.playoffStage === (status ? 2 : -2))
  //       .every(match => match.isFinished)
  //   ) {
  //     //3rd Place Match
  //     let challenger1;
  //     let challenger2;
  //     let match1 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 2 : -2)
  //     )[0];
  //     let match2 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 2 : -2)
  //     )[1];
  //     if (match1 && match2) {
  //       if (
  //         this.getPoints(match1.away_players, match1, match1.away_team) <
  //         this.getPoints(match1.home_players, match1, match1.home_team)
  //       ) {
  //         challenger1 = match1.away_team;
  //       } else {
  //         challenger1 = match1.home_team;
  //       }
  //       if (
  //         this.getPoints(match2.away_players, match2, match2.away_team) <
  //         this.getPoints(match2.home_players, match2, match2.home_team)
  //       ) {
  //         challenger2 = match2.away_team;
  //       } else {
  //         challenger2 = match2.home_team;
  //       }
  //       playoffMatches.push(
  //         this.formMatch("final", challenger1, challenger2, status ? 2.5 : -2.5)
  //       );
  //     }
  //   }
  //   if (
  //     this.playoffs.length &&
  //     this.playoffs
  //       .filter(match => match.playoffStage === (status ? 1 : -1))
  //       .every(match => match.isFinished)
  //   ) {
  //     // Semifinals
  //     let winner1;
  //     let match1 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 1 : -1)
  //     )[0];
  //     if (
  //       this.getPoints(match1.away_players, match1, match1.away_team) >
  //       this.getPoints(match1.home_players, match1, match1.home_team)
  //     ) {
  //       winner1 = match1.away_team;
  //     } else {
  //       winner1 = match1.home_team;
  //     }
  //     playoffMatches.push(this.formMatch("semifinal", group1[status ? 0 : 3], winner1, status ? 2 : -2));
  //     let winner2;
  //     let match2 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 1 : -1)
  //     )[1];
  //     if (
  //       this.getPoints(match2.away_players, match2, match2.away_team) >
  //       this.getPoints(match2.home_players, match2, match2.home_team)
  //     ) {
  //       winner2 = match2.away_team;
  //     } else {
  //       winner2 = match2.home_team;
  //     }
  //     playoffMatches.push(this.formMatch("semifinal", group2[status ? 0 : 3], winner2, status ? 2 : -2));
  //   }
  //   if (
  //     this.playoffs.length &&
  //     this.playoffs
  //       .filter(match => match.playoffStage === (status ? 1 : -1))
  //       .every(match => match.isFinished)
  //   ) {
  //     // playoffs Losers Game
  //     let loser1;
  //     let match1 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 1 : -1)
  //     )[0];
  //     if (
  //       this.getPoints(match1.away_players, match1, match1.away_team) <
  //       this.getPoints(match1.home_players, match1, match1.home_team)
  //     ) {
  //       loser1 = match1.away_team;
  //     } else {
  //       loser1 = match1.home_team;
  //     }
  //     let loser2;
  //     let match2 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 1 : -1)
  //     )[1];
  //     if (
  //       this.getPoints(match2.away_players, match2, match2.away_team) <
  //       this.getPoints(match2.home_players, match2, match2.home_team)
  //     ) {
  //       loser2 = match2.away_team;
  //     } else {
  //       loser2 = match2.home_team;
  //     }
  //     playoffMatches.push(this.formMatch("quarterfinal", loser1, loser2, status ? 0.5 : -0.5));
  //   }
  //   // playoffs
  //   playoffMatches.push(
  //     this.formMatch("quarterfinal",
  //       group1[status ? 1 : 4],
  //       group2[status ? 2 : 5],
  //       status ? 1 : -1
  //     )
  //   );
  //   playoffMatches.push(
  //     this.formMatch("quarterfinal",
  //       group2[status ? 1 : 4],
  //       group1[status ? 2 : 5],
  //       status ? 1 : -1
  //     )
  //   );
  // },
  // getWC4Final(playoffMatches, status) {
  //   const group1 = this.groups[0];
  //   const group2 = this.groups[1];
  //   const group3 = this.groups[2];
  //   const group4 = this.groups[3];

  //   playoffMatches.push(
  //     this.formMatch("quarterfinal",
  //       group1[status ? 1 : 4],
  //       group2[status ? 2 : 5],
  //       status ? 1 : -1
  //     )
  //   );
  //   playoffMatches.push(
  //     this.formMatch("quarterfinal",
  //       group2[status ? 1 : 4],
  //       group1[status ? 2 : 5],
  //       status ? 1 : -1
  //     )
  //   );
  //   playoffMatches.push(
  //     this.formMatch("quarterfinal",
  //       group3[status ? 1 : 4],
  //       group4[status ? 2 : 5],
  //       status ? 1 : -1
  //     )
  //   );
  //   playoffMatches.push(
  //     this.formMatch("quarterfinal",
  //       group4[status ? 1 : 4],
  //       group3[status ? 2 : 5],
  //       status ? 1 : -1
  //     )
  //   );

  //   // Wildcard Losers
  //   if (
  //     this.playoffs.length &&
  //     this.playoffs
  //       .filter(match => match.playoffStage === (status ? 1 : -1))
  //       .every(match => match.isFinished)
  //   ) {
  //     let loser1;
  //     let loser2;
  //     let loser3;
  //     let loser4;

  //     let match1 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 1 : -1)
  //     )[0];
  //     let match2 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 1 : -1)
  //     )[1];
  //     let match3 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 1 : -1)
  //     )[2];
  //     let match4 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 1 : -1)
  //     )[3];

  //     if (match1 && match2 && match3 && match4) {
  //       if (
  //         this.getPoints(match1.away_players, match1, match1.away_team) <
  //         this.getPoints(match1.home_players, match1, match1.home_team)
  //       ) {
  //         loser1 = match1.away_team;
  //       } else {
  //         loser1 = match1.home_team;
  //       }
  //       if (
  //         this.getPoints(match2.away_players, match2, match2.away_team) <
  //         this.getPoints(match2.home_players, match2, match2.home_team)
  //       ) {
  //         loser2 = match2.away_team;
  //       } else {
  //         loser2 = match2.home_team;
  //       }
  //       if (
  //         this.getPoints(match3.away_players, match3, match3.away_team) <
  //         this.getPoints(match3.home_players, match3, match3.home_team)
  //       ) {
  //         loser3 = match3.away_team;
  //       } else {
  //         loser3 = match3.home_team;
  //       }
  //       if (
  //         this.getPoints(match4.away_players, match4, match4.away_team) <
  //         this.getPoints(match4.home_players, match4, match4.home_team)
  //       ) {
  //         loser4 = match4.away_team;
  //       } else {
  //         loser4 = match4.home_team;
  //       }

  //       playoffMatches.push(
  //         this.formMatch("quarterfinal", loser1, loser2, status ? 0.5 : -0.5)
  //       );
  //       playoffMatches.push(
  //         this.formMatch("quarterfinal", loser3, loser4, status ? 0.5 : -0.5)
  //       );
  //     }
  //   }

  //   // 9-12 Place Matches
  //   if (
  //     this.playoffs.length &&
  //     this.playoffs
  //       .filter(match => match.playoffStage === (status ? 0.5 : -0.5))
  //       .every(match => match.isFinished)
  //   ) {
  //     let loser1;
  //     let loser2;
  //     let winner1;
  //     let winner2;

  //     let match1 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 0.5 : -0.5)
  //     )[0];
  //     let match2 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 0.5 : -0.5)
  //     )[1];
  //     if (match1 && match2) {
  //       if (
  //         this.getPoints(match1.away_players, match1, match1.away_team) <
  //         this.getPoints(match1.home_players, match1, match1.home_team)
  //       ) {
  //         loser1 = match1.away_team;
  //         winner1 = match1.home_team;
  //       } else {
  //         loser1 = match1.home_team;
  //         winner1 = match1.away_team;
  //       }
  //       if (
  //         this.getPoints(match2.away_players, match2, match2.away_team) <
  //         this.getPoints(match2.home_players, match2, match2.home_team)
  //       ) {
  //         loser2 = match2.away_team;
  //         winner2 = match2.home_team;
  //       } else {
  //         loser2 = match2.home_team;
  //         winner2 = match2.away_team;
  //       }
  //       playoffMatches.push(
  //         this.formMatch("semifinals", loser1, loser2, status ? 1.25 : -1.25)
  //       );
  //       playoffMatches.push(
  //         this.formMatch("semifinals", winner1, winner2, status ? 1.5 : -1.5)
  //       );
  //     }
  //   }

  //   // 1/4 game
  //   if (
  //     this.playoffs.length &&
  //     this.playoffs
  //       .filter(match => match.playoffStage === (status ? 1 : -1))
  //       .every(match => match.isFinished)
  //   ) {
  //     let quarterfinalist1;
  //     let quarterfinalist2;
  //     let quarterfinalist3;
  //     let quarterfinalist4;

  //     let match1 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 1 : -1)
  //     )[0];
  //     let match2 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 1 : -1)
  //     )[1];
  //     let match3 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 1 : -1)
  //     )[2];
  //     let match4 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 1 : -1)
  //     )[3];

  //     if (match1 && match2 && match3 && match4) {
  //       if (
  //         this.getPoints(match1.away_players, match1, match1.away_team) >
  //         this.getPoints(match1.home_players, match1, match1.home_team)
  //       ) {
  //         quarterfinalist1 = match1.away_team;
  //       } else {
  //         quarterfinalist1 = match1.home_team;
  //       }
  //       if (
  //         this.getPoints(match2.away_players, match2, match2.away_team) >
  //         this.getPoints(match2.home_players, match2, match2.home_team)
  //       ) {
  //         quarterfinalist2 = match2.away_team;
  //       } else {
  //         quarterfinalist2 = match2.home_team;
  //       }
  //       if (
  //         this.getPoints(match3.away_players, match3, match3.away_team) >
  //         this.getPoints(match3.home_players, match3, match3.home_team)
  //       ) {
  //         quarterfinalist3 = match3.away_team;
  //       } else {
  //         quarterfinalist3 = match3.home_team;
  //       }
  //       if (
  //         this.getPoints(match4.away_players, match4, match4.away_team) >
  //         this.getPoints(match4.home_players, match4, match4.home_team)
  //       ) {
  //         quarterfinalist4 = match4.away_team;
  //       } else {
  //         quarterfinalist4 = match4.home_team;
  //       }
  //       playoffMatches.push(
  //         this.formMatch("quarterfinal",
  //           group1[status ? 0 : 3],
  //           quarterfinalist1,
  //           status ? 2 : -2
  //         )
  //       );
  //       playoffMatches.push(
  //         this.formMatch("quarterfinal",
  //           group2[status ? 0 : 3],
  //           quarterfinalist2,
  //           status ? 2 : -2
  //         )
  //       );
  //       playoffMatches.push(
  //         this.formMatch("quarterfinal",
  //           group3[status ? 0 : 3],
  //           quarterfinalist3,
  //           status ? 2 : -2
  //         )
  //       );
  //       playoffMatches.push(
  //         this.formMatch("quarterfinal",
  //           group4[status ? 0 : 3],
  //           quarterfinalist4,
  //           status ? 2 : -2
  //         )
  //       );
  //     }
  //   }

  //   // Quarterfinals Losers
  //   if (
  //     this.playoffs.length &&
  //     this.playoffs
  //       .filter(match => match.playoffStage === (status ? 2 : -2))
  //       .every(match => match.isFinished)
  //   ) {
  //     let loser1;
  //     let loser2;
  //     let loser3;
  //     let loser4;

  //     let match1 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 2 : -2)
  //     )[0];
  //     let match2 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 2 : -2)
  //     )[1];
  //     let match3 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 2 : -2)
  //     )[2];
  //     let match4 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 2 : -2)
  //     )[3];

  //     if (match1 && match2 && match3 && match4) {
  //       if (
  //         this.getPoints(match1.away_players, match1, match1.away_team) <
  //         this.getPoints(match1.home_players, match1, match1.home_team)
  //       ) {
  //         loser1 = match1.away_team;
  //       } else {
  //         loser1 = match1.home_team;
  //       }
  //       if (
  //         this.getPoints(match2.away_players, match2, match2.away_team) <
  //         this.getPoints(match2.home_players, match2, match2.home_team)
  //       ) {
  //         loser2 = match2.away_team;
  //       } else {
  //         loser2 = match2.home_team;
  //       }
  //       if (
  //         this.getPoints(match3.away_players, match3, match3.away_team) <
  //         this.getPoints(match3.home_players, match3, match3.home_team)
  //       ) {
  //         loser3 = match3.away_team;
  //       } else {
  //         loser3 = match3.home_team;
  //       }
  //       if (
  //         this.getPoints(match4.away_players, match4, match4.away_team) <
  //         this.getPoints(match4.home_players, match4, match4.home_team)
  //       ) {
  //         loser4 = match4.away_team;
  //       } else {
  //         loser4 = match4.home_team;
  //       }
  //       playoffMatches.push(
  //         this.formMatch("quarterfinal", loser1, loser2, status ? 2.5 : -2.5)
  //       );
  //       playoffMatches.push(
  //         this.formMatch("quarterfinal", loser3, loser4, status ? 2.5 : -2.5)
  //       );
  //     }
  //   }

  //   //5-8 Place Matches
  //   if (
  //     this.playoffs.length &&
  //     this.playoffs
  //       .filter(match => match.playoffStage === (status ? 2.5 : -2.5))
  //       .every(match => match.isFinished)
  //   ) {
  //     let loser1;
  //     let loser2;
  //     let winner1;
  //     let winner2;

  //     let match1 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 2.5 : -2.5)
  //     )[0];
  //     let match2 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 2.5 : -2.5)
  //     )[1];
  //     if (match1 && match2) {
  //       if (
  //         this.getPoints(match1.away_players, match1, match1.away_team) <
  //         this.getPoints(match1.home_players, match1, match1.home_team)
  //       ) {
  //         loser1 = match1.away_team;
  //         winner1 = match1.home_team;
  //       } else {
  //         loser1 = match1.home_team;
  //         winner1 = match1.away_team;
  //       }
  //       if (
  //         this.getPoints(match2.away_players, match2, match2.away_team) <
  //         this.getPoints(match2.home_players, match2, match2.home_team)
  //       ) {
  //         loser2 = match2.away_team;
  //         winner2 = match2.home_team;
  //       } else {
  //         loser2 = match2.home_team;
  //         winner2 = match2.away_team;
  //       }
  //       playoffMatches.push(
  //         this.formMatch("quarterfinal", loser1, loser2, status ? 2.25 : -2.25)
  //       );
  //       playoffMatches.push(
  //         this.formMatch("quarterfinal", winner1, winner2, status ? 2.75 : -2.75)
  //       );
  //     }
  //   }

  //   // Semifinals
  //   if (
  //     this.playoffs.length &&
  //     this.playoffs
  //       .filter(match => match.playoffStage === (status ? 2 : -2))
  //       .every(match => match.isFinished)
  //   ) {
  //     let semiFinalist1;
  //     let semiFinalist2;
  //     let semiFinalist3;
  //     let semiFinalist4;

  //     let match1 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 2 : -2)
  //     )[0];
  //     let match2 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 2 : -2)
  //     )[1];
  //     let match3 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 2 : -2)
  //     )[2];
  //     let match4 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 2 : -2)
  //     )[3];

  //     if (match1 && match2) {
  //       if (
  //         this.getPoints(match1.away_players, match1, match1.away_team) >
  //         this.getPoints(match1.home_players, match1, match1.home_team)
  //       ) {
  //         semiFinalist1 = match1.away_team;
  //       } else {
  //         semiFinalist1 = match1.home_team;
  //       }
  //       if (
  //         this.getPoints(match2.away_players, match2, match2.away_team) >
  //         this.getPoints(match2.home_players, match2, match2.home_team)
  //       ) {
  //         semiFinalist2 = match2.away_team;
  //       } else {
  //         semiFinalist2 = match2.home_team;
  //       }

  //       if (
  //         this.getPoints(match3.away_players, match3, match3.away_team) >
  //         this.getPoints(match3.home_players, match3, match3.home_team)
  //       ) {
  //         semiFinalist3 = match3.away_team;
  //       } else {
  //         semiFinalist3 = match3.home_team;
  //       }

  //       if (
  //         this.getPoints(match4.away_players, match4, match4.away_team) >
  //         this.getPoints(match4.home_players, match4, match4.home_team)
  //       ) {
  //         semiFinalist4 = match4.away_team;
  //       } else {
  //         semiFinalist4 = match4.home_team;
  //       }
  //       playoffMatches.push(
  //         this.formMatch("quarterfinal", semiFinalist1, semiFinalist2, status ? 3 : -3)
  //       );
  //       playoffMatches.push(
  //         this.formMatch("quarterfinal", semiFinalist3, semiFinalist4, status ? 3 : -3)
  //       );
  //     }
  //   }

  //   //3rd Place Match
  //   if (
  //     this.playoffs.length &&
  //     this.playoffs
  //       .filter(match => match.playoffStage === (status ? 3 : -3))
  //       .every(match => match.isFinished)
  //   ) {
  //     let challenger1;
  //     let challenger2;

  //     let match1 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 3 : -3)
  //     )[0];
  //     let match2 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 3 : -3)
  //     )[1];

  //     if (match1 && match2) {
  //       if (
  //         this.getPoints(match1.away_players, match1, match1.away_team) <
  //         this.getPoints(match1.home_players, match1, match1.home_team)
  //       ) {
  //         challenger1 = match1.away_team;
  //       } else {
  //         challenger1 = match1.home_team;
  //       }
  //       if (
  //         this.getPoints(match2.away_players, match2, match2.away_team) <
  //         this.getPoints(match2.home_players, match2, match2.home_team)
  //       ) {
  //         challenger2 = match2.away_team;
  //       } else {
  //         challenger2 = match2.home_team;
  //       }

  //       playoffMatches.push(
  //         this.formMatch("quarterfinal", challenger1, challenger2, status ? 3.5 : -3.5)
  //       );
  //     }
  //   }

  //   //FINAL
  //   if (
  //     this.playoffs.length &&
  //     this.playoffs
  //       .filter(match => match.playoffStage === (status ? 3 : -3))
  //       .every(match => match.isFinished)
  //   ) {
  //     let finalist1;
  //     let finalist2;

  //     let match1 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 3 : -3)
  //     )[0];
  //     let match2 = this.playoffs.filter(
  //       match => match.playoffStage === (status ? 3 : -3)
  //     )[1];

  //     if (match1 && match2) {
  //       if (
  //         this.getPoints(match1.away_players, match1, match1.away_team) >
  //         this.getPoints(match1.home_players, match1, match1.home_team)
  //       ) {
  //         finalist1 = match1.away_team;
  //       } else {
  //         finalist1 = match1.home_team;
  //       }
  //       if (
  //         this.getPoints(match2.away_players, match2, match2.away_team) >
  //         this.getPoints(match2.home_players, match2, match2.home_team)
  //       ) {
  //         finalist2 = match2.away_team;
  //       } else {
  //         finalist2 = match2.home_team;
  //       }
  //       playoffMatches.push(
  //         this.formMatch("quarterfinal", finalist1, finalist2, status ? 4 : -4)
  //       );
  //     }
  //   }
  // },
  // async singlePlayoffMatches() {
  //   const playoffMatches = [];
  //   if (this.groups.length === 2) {
  //     // ============================== 2 groups - 2 semifinals - Winner Bracket ==============================
  //     this.getSE2Final(playoffMatches, true);
  //     // ============================== 2 groups - 2 semifinals - Consolation Bracket ==============================
  //     if (this.groups.every(group => group.length >= 4)) {
  //       this.getSE2Final(playoffMatches, false);
  //     } else if (this.groups.every(group => group.length === 3)) {
  //       playoffMatches.push(
  //         this.formMatch("quarterfinal", this.groups[0][2], this.groups[1][2], -1)
  //       );
  //     }
  //   } else if (this.groups.length === 3) {
  //     // ============================== 3 groups - 2 semifinals - Winner Bracket ==============================
  //     this.getSE3Final(playoffMatches, true);
  //     // ============================== 3 groups - 2 semifinals - Consolation Bracket ==============================
  //     if (this.groups.every(group => group.length >= 4)) {
  //       this.getSE3Final(playoffMatches, false);
  //     }
  //   } else if (this.groups.length === 4) {
  //     // ============================== 4 groups - 4 quarterfinals - Winner Bracket ==============================
  //     if (this.sizeOfBrackets === 4) {
  //       this.getSE2Final(playoffMatches, true);
  //     } else {
  //       this.getSE4Final(playoffMatches, true);
  //     }
  //     // ============================== 4 groups - 4 quarterfinals - Consolation Bracket ==============================
  //     if (this.groups.every(group => group.length === 4)) {
  //       this.getSE4Final(playoffMatches, false);
  //     } else if (this.groups.every(group => group.length === 3)) {
  //       playoffMatches.push(
  //         this.formMatch("quarterfinal", this.groups[0][2], this.groups[1][2], -1)
  //       );
  //       playoffMatches.push(
  //         this.formMatch("quarterfinal", this.groups[2][2], this.groups[3][2], -1)
  //       );
  //       if (
  //         this.playoffs.length &&
  //         this.playoffs
  //           .filter(match => match.playoffStage === -1)
  //           .every(match => match.isFinished)
  //       ) {
  //         let winner1;
  //         let winner2;
  //         let loser1;
  //         let loser2;

  //         let match1 = this.playoffs.filter(
  //           match => match.playoffStage === -1
  //         )[0];
  //         let match2 = this.playoffs.filter(
  //           match => match.playoffStage === -1
  //         )[1];

  //         if (match1 && match2) {
  //           if (
  //             this.getPoints(match1.away_players, match1, match1.away_team) >
  //             this.getPoints(match1.home_players, match1, match1.home_team)
  //           ) {
  //             winner1 = match1.away_team;
  //             loser1 = match1.home_team;
  //           } else {
  //             winner1 = match1.home_team;
  //             loser1 = match1.away_team;
  //           }
  //           if (
  //             this.getPoints(match2.away_players, match2, match2.away_team) >
  //             this.getPoints(match2.home_players, match2, match2.home_team)
  //           ) {
  //             winner2 = match2.away_team;
  //             loser2 = match2.home_team;
  //           } else {
  //             winner2 = match2.home_team;
  //             loser2 = match2.away_team;
  //           }
  //           playoffMatches.push(this.formMatch("quarterfinal", winner1, winner2, -3));
  //           playoffMatches.push(this.formMatch("quarterfinal", loser1, loser2, -2.5));
  //         }
  //       }
  //     }
  //   }
  //   let playoffStages = [
  //     2,
  //     -2,
  //     3,
  //     -3,
  //     0.5,
  //     -0.5,
  //     1.25,
  //     -1.25,
  //     1.5,
  //     -1.5,
  //     2.5,
  //     -2.5,
  //     3.5,
  //     -3.5
  //   ];
  //   for (let i = 0; i < playoffStages.length; i++) {
  //     const stage = playoffStages[i];
  //     if (
  //       this.playoffs.length &&
  //       playoffMatches.filter(match => match.playoffStage === stage).length &&
  //       !this.playoffs.some(match => match.playoffStage === stage)
  //     ) {
  //       try {
  //         await this.$http.post(
  //           "/match/addManyToPlayoff",
  //           playoffMatches.filter(match => match.playoffStage === stage)
  //         );
  //       } catch (error) {
  //         console.log(error);
  //       }
  //     }
  //   }
  //   await this.getPlayoffMatches('single')
  // },
  // async ladderPlayoffMatches() {
  //   const playoffMatches = [];

  //   if (this.groups.length === 2) {
  //     const group1 = this.groups[0];
  //     const group2 = this.groups[1];

  //     for (let i = 0; i < Math.min(group1.length, group2.length); i++) {
  //       playoffMatches.push({
  //         title: `${this.$t("competition.match_for")} ${i + i + 1}-${i +
  //           i +
  //           2}`,
  //         stage: this.competition.stages.find(({ isCurrent }) => isCurrent),
  //         round: this.rounds.find(round => round.isPlayoff),
  //         home_team: group1[i],
  //         away_team: group2[i],
  //         home_players: group1[i].players.map(({ player }) => {
  //           return { player: player, goals: 0, points: 0, cards: [] };
  //         }),
  //         away_players: group2[i].players.map(({ player }) => {
  //           return { player: player, goals: 0, points: 0, cards: [] };
  //         }),
  //         isFinished: false
  //       });
  //     }
  //   }
  //   if (!this.ladder.length) {
  //     try {
  //       const match = await this.$http.post("/match/addManyToPlayoff", playoffMatches);
  //       this.ladder.push(...match.data);
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   }
  // },
  // async wildCardPlayoffMatches() {
  //   const playoffMatches = [];
  //   if (this.groups.length % 2 === 0) {
  //     if (this.groups.length === 2) {
  //       this.getWC2Final(playoffMatches, true);

  //       if (this.groups.every(group => group.length >= 6)) {
  //         this.getWC2Final(playoffMatches, false);
  //       } else if (this.groups.every(group => group.length === 4)) {
  //         playoffMatches.push(
  //           this.formMatch("quarterfinal", this.groups[0][3], this.groups[1][3], -1)
  //         );
  //       }
  //     }
  //     // ====================================================== WILDCARD =======================================================

  //     if (this.groups.length === 4) {
  //       // ==========================  4 groups - 4 semifinals - Winner Bracket  ==========================
  //       this.getWC4Final(playoffMatches, true);
  //       // ==========================  4 groups - 4 semifinals - Consolation Bracket  ==========================
  //       if (this.groups.every(group => group.length >= 6)) {
  //         this.getWC4Final(playoffMatches, false);
  //       } else if (this.groups.every(group => group.length === 4)) {
  //         playoffMatches.push(
  //           this.formMatch("quarterfinal", this.groups[0][3], this.groups[1][3], -1)
  //         );
  //         playoffMatches.push(
  //           this.formMatch("quarterfinal", this.groups[2][3], this.groups[3][3], -1)
  //         );
  //         if (
  //           this.playoffs.length &&
  //           this.playoffs
  //             .filter(match => match.playoffStage === -1)
  //             .every(match => match.isFinished)
  //         ) {
  //           let winner1;
  //           let winner2;
  //           let loser1;
  //           let loser2;

  //           let match1 = this.playoffs.filter(
  //             match => match.playoffStage === -1
  //           )[0];
  //           let match2 = this.playoffs.filter(
  //             match => match.playoffStage === -1
  //           )[1];

  //           if (match1 && match2) {
  //             if (
  //               this.getPoints(match1.away_players, match1, match1.away_team) >
  //               this.getPoints(match1.home_players, match1, match1.home_team)
  //             ) {
  //               winner1 = match1.away_team;
  //               loser1 = match1.home_team;
  //             } else {
  //               winner1 = match1.home_team;
  //               loser1 = match1.away_team;
  //             }
  //             if (
  //               this.getPoints(match2.away_players, match2, match2.away_team) >
  //               this.getPoints(match2.home_players, match2, match2.home_team)
  //             ) {
  //               winner2 = match2.away_team;
  //               loser2 = match2.home_team;
  //             } else {
  //               winner2 = match2.home_team;
  //               loser2 = match2.away_team;
  //             }
  //             playoffMatches.push(this.formMatch("quarterfinal", winner1, winner2, -4));
  //             playoffMatches.push(this.formMatch("quarterfinal", loser1, loser2, -3.5));
  //           }
  //         }
  //       }
  //     }
  //   }

  //   let playoffStages = [
  //     2,
  //     -2,
  //     3,
  //     -3,
  //     4,
  //     -4,
  //     0.5,
  //     -0.5,
  //     1.25,
  //     -1.25,
  //     1.5,
  //     -1.5,
  //     2.25,
  //     -2.25,
  //     2.5,
  //     -2.5,
  //     2.75,
  //     -2.75,
  //     3.5,
  //     -3.5
  //   ];
  //   if (!this.playoffs.length && playoffMatches.length) {
  //     try {
  //       await this.$http.post("/match/addManyToPlayoff", playoffMatches);
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   }
  //   for (let i = 0; i < playoffStages.length; i++) {
  //     const stage = playoffStages[i];
  //     if (
  //       this.playoffs.length &&
  //       playoffMatches.filter(match => match.playoffStage === stage).length &&
  //       !this.playoffs.some(match => match.playoffStage === stage)
  //     ) {
  //       try {
  //         await this.$http.post(
  //           "/match/addManyToPlayoff",
  //           playoffMatches.filter(match => match.playoffStage === stage)
  //         );
  //       } catch (error) {
  //         console.log(error);
  //       }
  //     }
  //   }
  // },
};



// WEBPACK FOOTER //
// ./src/components/competitions/brackets/bracketsMixin.js